{
  "recruiting": "Reclutamiento",
  "courses": "Cursos",
  "courses-page": {
    "title": "Cursos",
    "create": "Crear curso",
    "edit": "Editar curso",
    "empty": "Aún no hay cursos",
    "fields": {
      "title": "Título",
      "description": "Descripción",
      "documents-count": "Documentos"
    },
    "headers": {
      "title": "Título",
      "description": "Descripción",
      "documents": "Documentos",
      "actions": "Acciones"
    },
    "dialog": {
      "title-label": "Título",
      "description-label": "Descripción",
      "documents-label": "Documentos",
      "documents-placeholder": "Selecciona documentos de la base de conocimientos",
      "save": "Guardar",
      "cancel": "Cancelar"
    },
    "messages": {
      "created": "Curso creado",
      "updated": "Curso actualizado",
      "deleted": "Curso eliminado",
      "error": "Algo salió mal"
    },
    "confirm-delete": "¿Eliminar este curso? Esta acción no se puede deshacer."
  },
  "ai-study-chat": "Chat de estudio con IA",
  "ai-study-chat-page": {
    "title": "Chat de estudio con IA",
    "new-conversation": "Nueva conversación",
    "empty-sidebar": "Aún no hay conversaciones",
    "empty-thread": "Elige un curso o escenario para comenzar a aprender",
    "untitled": "Nuevo chat",
    "input-placeholder": "Escribe tu pregunta…",
    "send": "Enviar",
    "typing": "El asistente está escribiendo…",
    "sources": "Fuentes ({count})",
    "score": "relevancia",
    "retry": "Reintentar",
    "failed": "Error al enviar",
    "sources-label": "Fuentes",
    "copy": "Copiar",
    "copied": "Copiado",
    "search-placeholder": "Buscar conversaciones",
    "search-empty": "No se encontró nada",
    "empty": {
      "heading": "Listo para ayudarte a aprender",
      "subtitle": "Pregunta cualquier cosa sobre los materiales del curso — encontraré la respuesta en la base de conocimientos y mostraré las fuentes."
    },
    "groups": {
      "today": "Hoy",
      "yesterday": "Ayer",
      "earlier": "Anteriores"
    },
    "composer": {
      "context": "Contexto:",
      "hint": "Las respuestas son generadas por IA a partir de tus materiales · Enter para enviar, Shift+Enter para nueva línea"
    },
    "suggestions-fallback": [
      {
        "title": "Resumir los materiales",
        "subtitle": "Puntos clave"
      },
      {
        "title": "Crear un plan de estudio",
        "subtitle": "Por dónde empezar"
      },
      {
        "title": "Ponme a prueba",
        "subtitle": "Comprobación rápida"
      },
      {
        "title": "Explicar de forma sencilla",
        "subtitle": "Sin tecnicismos"
      }
    ],
    "suggestions-fallback-debrief": [
      { "title": "Evaluar esta sesión", "subtitle": "Conclusiones clave" },
      { "title": "¿Qué hice bien?", "subtitle": "Mis puntos fuertes" },
      { "title": "¿Dónde me equivoqué y por qué?", "subtitle": "Puntos de mejora" },
      { "title": "¿Qué debo mejorar en la siguiente sesión?", "subtitle": "Pasos concretos" }
    ],
    "suggestions-fallback-progress": [
      { "title": "¿Cómo evolucionan mis resultados?", "subtitle": "Entre sesiones" },
      { "title": "Mis habilidades fuertes y débiles", "subtitle": "Según las puntuaciones" },
      { "title": "¿En qué debería enfocarme?", "subtitle": "Prioridad de entrenamiento" },
      { "title": "Comparar mi primera y última sesión", "subtitle": "Qué ha mejorado" }
    ],
    "quota": {
      "remaining": "{count} mensajes restantes",
      "exhausted": "Se te han agotado los mensajes del chat de IA.",
      "unavailable": "El chat de IA no está disponible en tu plan."
    },
    "new-dialog": {
      "title": "Nueva conversación",
      "subtitle": "Elige la fuente de la que responderá la IA",
      "search": "Buscar…",
      "search-empty": "No se encontró nada",
      "source-type": "Fuente",
      "source-course": "Curso",
      "source-scenario": "Escenario",
      "source-competency": "Competencia",
      "pick-course": "Elige un curso",
      "pick-scenario": "Elige un escenario",
      "pick-competency": "Elige una competencia",
      "pick-target": "Todas las sesiones o una sesión específica",
      "all-games": "Todas las sesiones — mi progreso",
      "all-games-sub": "Tendencias de puntuación para esta competencia",
      "back": "Volver",
      "no-games": "No hay sesiones completadas",
      "empty-competencies": "Aún no hay sesiones completadas",
      "empty-competencies-hint": "Complete una sesión de un escenario con competencia y aquí aparecerá el análisis con IA",
      "empty-courses": "Aún no hay cursos disponibles",
      "empty-scenarios": "Aún no hay escenarios disponibles",
      "tag-game": "Sesión",
      "start": "Iniciar",
      "cancel": "Cancelar"
    },
    "stage": {
      "searching": "Buscando en tus materiales…",
      "reading": "Leyendo las fuentes…",
      "writing": "Escribiendo la respuesta…",
      "writing_sources": "Analizando {count} fragmentos…",
      "summarizing_short": "Organizando el contexto anterior",
      "searching_short": "Buscando en tus materiales",
      "reading_short": "Leyendo las fuentes",
      "writing_short": "Escribiendo la respuesta",
      "writing_sources_short": "Analizando {count} fragmentos"
    },
    "errors": {
      "send": "No se pudo enviar tu mensaje. Por favor, inténtalo de nuevo.",
      "quota": "Se alcanzó el límite de mensajes.",
      "rate_limit": "Demasiadas solicitudes. Espera un minuto e inténtalo de nuevo.",
      "provider_unsupported": "El chat de la base de conocimientos no está disponible con el proveedor de IA actual de tu organización.",
      "generic": "Algo salió mal."
    }
  },
  "base_title": "The Reflection",
  "base_title_ru": "SkillsTrainer",
  "404_title": "Página No Encontrada ⚠️",
  "404_description": "No pudimos encontrar la página que estás buscando.",
  "404_home": "Volver a Inicio",
  "401_title": "¡No estás autorizado! 🔐",
  "401_description": "No tienes permiso para acceder a esta página. ¡Vete a Inicio!",
  "401_home": "Volver a Inicio",
  "changes_saved": "Cambios guardados",
  "coming_soon": "Próximamente",
  " ": " ",
  "select_date_and_time": "Seleccionar fecha y hora",
  "select_date": "Seleccionar fecha",
  "chat": "Chat",
  "menu": "Menú",
  "games": "Sesiones",
  "tours": "Jornadas",
  "library": "Biblioteca",
  "library-video": "Video",
  "library-scorm": "Cursos",
  "library-documents": "Documentos",
  "scenarios": "Escenarios",
  "competencies": "Competencias",
  "competencies-list": "Lista",
  "skills": "Habilidades",
  "home": "Inicio",
  "home_player": "Participante",
  "player": "Participante",
  "home_expert": "Experto",
  "reports-analytics-tours": "Jornadas",
  "reports": "Informes",
  "ranking": "Clasificación",
  "analytics": "Analíticas",
  "support": "Soporte",
  "users": "Usuarios",
  "participants": "Participantes",
  "departments": "Departamentos",
  "positions": "Puestos",
  "user-custom-fields": "Campos personalizados",
  "administration": "Administración",
  "ai-assistants": "Asistentes de IA",
  "ai-profiles": "Perfiles de IA",
  "evaluation-rubrics": "Rúbricas de evaluación",
  "ai-connectors": "Conectores de IA",
  "Audit logs": "Registros de auditoría",
  "organizations": "Organizaciones",
  "loading": "Cargando...",
  "retry": "Reintentar",
  "previous": "Anterior",
  "next": "Siguiente",
  "save": "Guardar",
  "copy": "Copiar",
  "copy_failed": "No se pudo copiar automáticamente. Seleccione el texto del campo y cópielo manualmente (Ctrl+C o ⌘C).",
  "confirm": "Confirmar",
  "suggest": "Sugerir",
  "generate": "Generar",
  "cancel": "Cancelar",
  "close": "Cerrar",
  "search": "Buscar...",
  "accept": "Aceptar",
  "propose": "Proponer",
  "decline": "Rechazar",
  "send_request": "Enviar solicitud",
  "assign": "Asignar",
  "actions": " ",
  "evaluators": {
    "ai": "IA",
    "expert": "Experto",
    "player": "Participante",
    "manager": "Administrador",
    "head": "Responsable"
  },
  "statistics": {
    "date_from": "Desde",
    "date_to": "Hasta",
    "competence": "Competencia",
    "evaluator": "Evaluador",
    "last_games_effectiveness": {
      "effectiveness": "Efectividad",
      "title": "Evolución de efectividad"
    },
    "skill_trend": {
      "average_score": "Puntuación Promedio",
      "game": "Sesión",
      "score": "Puntuación",
      "title": "Puntuación Promedio por Competencias"
    },
    "player_competence_radar": {
      "title": "Estadísticas de Competencia",
      "top": "Top 10",
      "players_in_company": "Participantes en la empresa",
      "by_games": "Analíticas por sesiones",
      "subtitle": "Estadísticas Generales para Ti y Tu Empresa",
      "filter": "Filtro",
      "you": "Tú",
      "company": "Empresa",
      "average_score": "puntuación promedio",
      "skills_counted": "en {counted} de {total} habilidades"
    },
    "personal_radar": {
      "title": "Mi Radar de Competencias",
      "subtitle": "Tus habilidades comparadas con el promedio de la organización"
    },
    "skill_gap_heatmap": {
      "title": "Mapa de Calor de Brechas de Habilidades",
      "no_data": "No hay datos de evaluación disponibles para los filtros seleccionados"
    },
    "progress_over_time": {
      "title": "Progreso a lo Largo del Tiempo",
      "avg_score": "Puntuación Promedio",
      "week": "Semana",
      "month": "Mes",
      "no_data": "No hay datos para el período seleccionado"
    },
    "department_aggregation": {
      "title": "Comparación por Departamento",
      "avg_score": "Puntuación Promedio",
      "players": "Participantes",
      "no_data": "No hay datos de departamento disponibles para los filtros seleccionados"
    },
    "employee_comparison": {
      "title": "Comparación de Empleados",
      "subtitle": "Compara evaluaciones de habilidades de 2-3 empleados lado a lado",
      "select_players": "Selecciona 2-3 participantes para comparar",
      "max_players": "Máximo 3 participantes permitidos"
    },
    "score_distribution": {
      "title": "Distribución de Puntuaciones",
      "subtitle": "Distribución de puntuaciones de evaluación por competencia o habilidad",
      "count": "Evaluaciones",
      "q1": "Q1",
      "median": "Mediana",
      "q3": "Q3",
      "average": "Promedio",
      "no_data": "No hay datos de evaluación disponibles para los filtros seleccionados"
    },
    "evaluator_consistency": {
      "title": "Consistencia del Evaluador",
      "subtitle": "Correlación y puntuaciones promedio por tipos de evaluador",
      "correlation": "Matriz de Correlación",
      "correlation_method": "Pearson",
      "avg_by_type": "Promedio por Tipo de Evaluador",
      "pair_details": "Detalles por Pares",
      "corr_label": "Corr",
      "gap_label": "Brecha",
      "shared_label": "Comunes",
      "no_data": "No hay suficientes datos de evaluación para calcular la consistencia"
    },
    "engagement_dashboard": {
      "title": "Panel de Compromiso",
      "subtitle": "Rastrea la intensidad de actividad e identifica empleados que necesitan atención",
      "active_employees": "Empleados Activos",
      "avg_games_week": "Prom. Sesiones / Semana",
      "inactive_employees": "Empleados Inactivos",
      "inactive_threshold_days": "Umbral de inactividad (días)",
      "days_inactive": "{days} días inactivo",
      "last_game_date": "Última sesión: {date}",
      "no_games_yet": "Aún sin sesiones",
      "no_inactive": "No se encontraron empleados inactivos"
    },
    "strengths_weaknesses": {
      "title": "Fortalezas y Debilidades",
      "subtitle": "Tus 3 habilidades más fuertes y más débiles",
      "strengths": "Fortalezas",
      "weaknesses": "Áreas de Mejora",
      "no_data": "Aún no hay suficientes datos de evaluación"
    },
    "peer_percentile": {
      "title": "Percentil entre Pares",
      "subtitle": "Tu posición por habilidad comparada con tus compañeros en la organización",
      "top_percent": "Top {percent}%",
      "bottom_percent": "Inferior {percent}%",
      "no_data": "No hay suficientes datos de pares para calcular percentiles"
    },
    "evaluation_gap": {
      "title": "Brecha entre Autoevaluación y Evaluación IA",
      "subtitle": "Compara tu autoevaluación con la evaluación de IA para descubrir puntos ciegos",
      "self_assessment": "Autoevaluación",
      "ai_evaluation": "Evaluación IA",
      "gap": "Brecha",
      "skill": "Habilidad",
      "no_data": "No hay datos disponibles - se requieren tanto autoevaluaciones como evaluaciones de IA"
    },
    "improvement_velocity": {
      "title": "Velocidad de Mejora",
      "subtitle": "Cambio de puntuación comparando los últimos 30 días con los 30 días anteriores",
      "no_data": "No hay suficientes datos para calcular la mejora",
      "improved": "Mejorado",
      "declined": "Disminuido"
    },
    "activity_calendar": {
      "title": "Calendario de Actividad",
      "subtitle": "Participación diaria en sesiones durante los últimos 6 meses",
      "current_streak": "Racha Actual",
      "longest_streak": "Racha Más Larga",
      "total_games": "Total de Sesiones",
      "games_count": "{count} sesiones",
      "no_activity": "No se registró actividad en los últimos 6 meses"
    },
    "session_history": {
      "title": "Historial de Sesiones",
      "subtitle": "Tus sesiones recientes y resultados",
      "date": "Fecha",
      "scenario": "Escenario",
      "type": "Tipo",
      "score": "Puntuación",
      "status": "Estado",
      "types": {
        "player_vs_player": "Participante contra Participante",
        "player_vs_ai": "Participante contra IA",
        "training": "Entrenamiento"
      },
      "statuses": {
        "time_scheduling": "Programación de hora de inicio",
        "waiting_for_start": "Esperando inicio",
        "missed": "Perdido",
        "in_progress": "En progreso",
        "protocol_approval": "Aprobación de protocolo",
        "failed": "Fallido",
        "completed": "Completado"
      }
    }
  },
  "participant": {
    "upcoming_games": "Próximas sesiones",
    "for_rank_games": "Por calificar"
  },
  "roles": {
    "player": "Participante",
    "admin": "Superadministrador (sistema)",
    "scoped_admin": "Administrador principal",
    "observer": "Observador",
    "captain": "Capitán",
    "expert": "Experto",
    "lead_expert": "Experto principal",
    "manager": "Administrador",
    "support": "Soporte",
    "early_access": "Acceso anticipado",
    "head": "Responsable",
    "candidate": "Candidato"
  },
  "user-status": {
    "active": "Activo",
    "inactive": "Inactivo",
    "pending": "Pendiente"
  },
  "pagination": {
    "showing": "mostrando",
    "to": "a",
    "of": "de",
    "entries": "entradas"
  },
  "validator": {
    "required": "Este campo es obligatorio",
    "library": "El tamaño del archivo debe ser inferior a 500MB",
    "email": "El campo Email debe ser un correo electrónico válido",
    "password": "El campo debe contener al menos una mayúscula, una minúscula, un carácter especial y un dígito con un mínimo de 8 caracteres",
    "confirm": "La confirmación del campo Confirmar Contraseña no coincide",
    "at_least": "El campo debe contener al menos",
    "items": "elementos",
    "number": "Este campo debe ser un número entero",
    "is_odd": "Este campo debe ser par",
    "number_between": "Introduce un número entre",
    "number_and": "y",
    "date_range_required": "Rango requerido",
    "invalid_date_range": "Rango inválido",
    "invalid_date_format": "Formato de fecha inválido",
    "start_date_after_end_date": "La fecha de inicio debe ser anterior a la fecha de fin",
    "max_180_days": "Máximo 180 días"
  },
  "user": {
    "menu": {
      "settings": "Configuración",
      "statistics": "Estadísticas",
      "logout": "Cerrar sesión"
    }
  },
  "theme": {
    "system": "Sistema",
    "light": "Claro",
    "dark": "Oscuro"
  },
  "error": {
    "default": "Lo sentimos, ha ocurrido un error. Nuestros especialistas ya están al tanto y lo solucionarán lo antes posible.",
    "unauthorized": "Tu sesión ha expirado.",
    "contact-support": "Lo sentimos, ha ocurrido un error. Por favor, contacta con el soporte técnico",
    "forbidden": "Acceso denegado"
  },
  "confirmation": {
    "sure": "¿Estás seguro de que quieres eliminar la entrada?",
    "sure_return_to_time_scheduling": "¿Estás seguro de que quieres revertir la sesión a la etapa de coordinación de la hora de inicio?",
    "sure_restore": "¿Estás seguro de que quieres restaurar la entrada?",
    "sure_mark_failed": "¿Marcar la partida como fallida y eliminar permanentemente todas las evaluaciones y protocolos de los participantes?",
    "success": "¡Éxito!",
    "deleted": "Eliminado",
    "failed_marked": "Partida marcada como fallida",
    "restored": "Restaurado",
    "cancel": "Cancelado",
    "yes": "Sí",
    "no": "No"
  },
  "dashboards": {
    "player": {
      "summary": {
        "welcome": "Bienvenido de nuevo",
        "progress": "Tu progreso general",
        "stats": {
          "minutes": "Minutos en la sesión",
          "effectiveness": "Eficiencia",
          "completed_games_count": "Sesiones completadas",
          "total_games_count": "Sesiones en total"
        }
      },
      "cards": {
        "players_rating": {
          "title": "Clasificación de la empresa",
          "player": "Participante",
          "effectiveness": "Efectividad"
        }
      }
    },
    "head": {
      "my_stats": "Mis estadisticas",
      "subordinates": "Mis subordinados",
      "subordinate_stats": "Estadisticas del subordinado",
      "select_subordinate": "Seleccione un subordinado para ver sus estadisticas",
      "no_subordinates": "No hay subordinados asignados"
    }
  },
  "chat-page": {
    "last_game": "Última sesión",
    "chats": "Chats",
    "no-chats": "No se encontraron chats",
    "contacts": "Contactos",
    "choose": "Elegir contacto",
    "send": "Enviar",
    "type": "Escribe tu mensaje...",
    "no-contacts": "No se encontraron contactos",
    "search": "Buscar...",
    "start_conversation": "Iniciar conversación",
    "start_connecting": " Comienza a conectarte con la gente seleccionando uno de los contactos a la izquierda"
  },
  "scenarios-page": {
    "title": "Título",
    "export-docx": "Export .docx",
    "copy_title": "Copiar escenario",
    "generate_ai_title": "Generar escenario IA",
    "organization": "Empresa",
    "competence": "Competencia",
    "actions": " ",
    "add": "Añadir escenario",
    "ai-generate": "Generación IA",
    "copy": "Copiar escenario",
    "add_popup": "Añadir escenario",
    "delete": "Eliminar escenario",
    "edit": "Editar escenario",
    "edit_popup": "Editar escenario",
    "industries": [
      "FMCG/Venta al por menor",
      "Farmacéutico",
      "Bancos y Fintech",
      "Hoteles y Turismo",
      "Empresas de TI/SaaS",
      "Negocio de restaurantes/HoReCa",
      "E-commerce/Mercados",
      "Manufactura/Industria 4.0",
      "Logística y T&L",
      "Telecomunicaciones",
      "Educación/EdTech",
      "Industria química",
      "Software de gestión de cadena de suministro",
      "Sector público/Organizaciones sin fines de lucro"
    ],
    "case_types": [
      "Liderazgo y People-Management",
      "Reclutamiento y evaluación de personal",
      "Ventas y servicio al cliente",
      "Negociaciones e influencia",
      "Gestión de conflictos",
      "Estrategia y ejecución"
    ],
    "cases": [
      [
        "Establecimiento de objetivos SMART/OKR",
        "Dar retroalimentación de desarrollo (SBI/COIN)",
        "Delegación",
        "Coaching GROW",
        "Evaluación de rendimiento",
        "Mentoría"
      ],
      [
        "Entrevista basada en competencias (CBI)",
        "Evaluación/Centro de evaluación",
        "Sesión de incorporación"
      ],
      [
        "Venta clásica de producto/servicio",
        "Manejo de objeciones",
        "Venta adicional/cruzada",
        "Manejo de quejas",
        "Venta multicanal"
      ],
      [
        "Negociaciones corporativas internas sobre presupuesto/recursos",
        "Contrato cliente/proveedor",
        "Negociaciones de crisis"
      ],
      [
        "Conflicto interpersonal en equipo",
        "Gerente-subordinado",
        "Conflicto de valores/ética"
      ],
      [
        "Priorización de cartera de proyectos",
        "Gestión del cambio",
        "Análisis de riesgos"
      ]
    ],
    "formats": [
      "1-1",
      "Grupos"
    ],
    "labels": {
      "industry": "Industria",
      "case_type": "Tipo de caso",
      "case": "Caso",
      "format": "Formato",
      "duration": "Duración (minutos)",
      "game_vs_ai": "Sesión contra IA",
      "level": "Nivel",
      "competence": "Competencia",
      "description": "Descripción del escenario",
      "description_hint": "Opcionalmente, describa el escenario que desea generar (máx. 4000 caracteres)"
    },
    "generating_in_progress": "Generando escenario, por favor espere..."
  },
  "analytics-page": {
    "tours-page": {
      "tour": "Jornada",
      "full_name": "Participante",
      "games_count": "Sesiones",
      "team": "Equipo",
      "export": "Exportar",
      "effectiveness": "Efectividad"
    }
  },
  "report-filters": {
    "department": "Departamento",
    "position": "Puesto",
    "employee": "Empleado",
    "scenario": "Escenario",
    "competence": "Competencia",
    "period": "Período",
    "reset": "Restablecer",
    "only-period-competence": "Solo se aplican el período y la competencia"
  },
  "competencies-page": {
    "title": "Título",
    "export-docx": "Export .docx",
    "skills": "Habilidades",
    "text": "Texto",
    "display_order": "Ordenar",
    "ai-assistant": "Asistente de IA",
    "language": "Idioma",
    "department": "Departamento",
    "evaluation-format": "Formato de evaluación",
    "evaluation-format-skills": "Puntuación por habilidades",
    "evaluation-format-checklist": "Lista de verificación binaria",
    "rubric": "Rúbrica",
    "evaluation-target": "¿A quién evaluamos?",
    "evaluation-both": "Ambos participantes",
    "evaluation-team-a": "Solo equipo A",
    "evaluation-both-tooltip": "Se evalúan ambos participantes - adecuado para escenarios de negociación",
    "evaluation-team-a-tooltip": "Solo se evalúa al líder - formato de retroalimentación",
    "actions": " ",
    "add": "Añadir competencia",
    "add_popup": "Añadir competencia",
    "delete": "Eliminar competencia",
    "edit": "Editar competencia",
    "edit_popup": "Editar competencia"
  },
  "faq-page": {
    "title": "Preguntas",
    "question": "Pregunta",
    "text": "Respuesta",
    "is_shared": "Disponible para todas las empresas",
    "actions": " ",
    "visibility": "Visibilidad",
    "visible_to_all": "Visible para todos los usuarios",
    "visible_to_managers": "Visible solo para gerentes",
    "add": "Añadir pregunta",
    "add_popup": "Añadir pregunta",
    "delete": "Eliminar pregunta",
    "edit": "Editar pregunta",
    "edit_popup": "Editar pregunta"
  },
  "evaluation-rubrics-page": {
    "name": "Nombre",
    "actions": " ",
    "add": "Añadir rúbrica",
    "add_popup": "Añadir rúbrica",
    "edit": "Editar rúbrica",
    "edit_popup": "Editar rúbrica",
    "delete": "Eliminar rúbrica",
    "updated_at": "Actualizado",
    "hint": "Las rúbricas definen listas de verificación binarias para evaluar juegos. Asocia una rúbrica a una competencia para cambiarla a evaluación por lista de verificación.",
    "used_by": "Usada por",
    "used_by_value": "Competencias: {count}",
    "not_used": "Sin uso",
    "delete_blocked_hint": "No se puede eliminar: usada por {count} competencias.",
    "criteria": "Criterios",
    "criterion_text": "Criterio",
    "criterion_category": "Categoría (opcional)",
    "add_criterion": "Añadir criterio",
    "criteria_hint": "Arrastra para reordenar. Agrupa criterios relacionados asignándoles la misma categoría.",
    "drag_to_reorder": "Arrastrar para reordenar",
    "no_criteria": "Añade al menos un criterio.",
    "versions": "Historial de versiones",
    "no_versions": "Aún no hay versiones",
    "criteria_count": "{count} criterios",
    "restore": "Restaurar",
    "restore_confirm": "¿Restaurar esta versión? Se convertirá en la actual.",
    "restored": "Versión restaurada",
    "current_version": "Actual",
    "author": "Autor",
    "error": "Algo salió mal."
  },
  "ai-connectors-page": {
    "title": "Conectores de IA",
    "is_shared": "Disponible para todas las organizaciones",
    "actions": " ",
    "add": "Añadir conector",
    "add_popup": "Añadir conector",
    "delete": "Eliminar conector",
    "edit": "Editar conector",
    "edit_popup": "Editar conector",
    "label": "Etiqueta",
    "provider": "Proveedor",
    "service": "Servicio",
    "status": "Estado",
    "region": "Región",
    "endpoint": "Punto final",
    "secret": "Contraseña/Clave",
    "maxConcurrency": "Concurrencia máxima",
    "timeoutSec": "Tiempo de espera",
    "sortOrder": "Orden",
    "config": "Configuración",
    "modelPrimary": "Modelo primary",
    "modelLight": "Modelo light",
    "modelLightHint": "Si está vacío, las llamadas light usan el modelo primary",
    "folderId": "ID de folder",
    "models": "Modelos",
    "is_default": "Default",
    "notes": "Notas"
  },
  "skills-page": {
    "title": "Título",
    "display_order": "Ordenar",
    "competence": "Competencia",
    "text": "Indicadores",
    "actions": " ",
    "add": "Añadir habilidad",
    "add_popup": "Añadir habilidad",
    "delete": "Eliminar habilidad",
    "edit": "Editar habilidad",
    "edit_popup": "Editar habilidad"
  },
  "departments-page": {
    "title": "Título",
    "actions": " ",
    "add": "Añadir departamento",
    "add_popup": "Añadir departamento",
    "delete": "Eliminar departamento",
    "edit": "Editar departamento",
    "edit_popup": "Editar departamento"
  },
  "tours-page": {
    "title": "Título",
    "actions": " ",
    "add": "Añadir jornada",
    "add_popup": "Añadir jornada",
    "delete": "Eliminar jornada",
    "edit": "Editar jornada",
    "edit_popup": "Editar jornada"
  },
  "library-page": {
    "title": "Título",
    "text": "Descripción",
    "video": "Video",
    "courses": "Cursos",
    "video_link_copy": "Copiar enlace",
    "video_in_process": "El video se está procesando...",
    "is_public": "Es público",
    "actions": " ",
    "add": "Añadir video",
    "add_popup": "Añadir video",
    "delete": "Eliminar video",
    "edit": "Editar video",
    "edit_popup": "Editar video"
  },
  "library-documents-page": {
    "title": "Título",
    "actions": " ",
    "add": "Añadir documento",
    "add_popup": "Añadir documento",
    "delete": "Eliminar documento",
    "edit": "Editar documento",
    "edit_popup": "Editar documento",
    "file": "Archivo"
  },
  "scorm-page": {
    "title": "Título",
    "actions": " ",
    "add": "Añadir curso",
    "loading": "El curso se está cargando...",
    "add_popup": "Añadir curso",
    "delete": "Eliminar curso",
    "edit": "Editar curso",
    "edit_popup": "Editar curso",
    "zip_file": "Archivo ZIP"
  },
  "ai-assistants-page": {
    "external_id": "ID",
    "description": "Descripción",
    "actions": " ",
    "add": "Añadir asistente de IA",
    "add_popup": "Añadir asistente de IA",
    "delete": "Eliminar asistente de IA",
    "edit": "Editar asistente de IA",
    "edit_popup": "Editar asistente de IA"
  },
  "ai-prompts-page": {
    "name": "Nombre",
    "content": "Contenido",
    "actions": " ",
    "add": "Añadir prompt de IA",
    "add_popup": "Añadir prompt de IA",
    "delete": "Eliminar prompt de IA",
    "edit": "Editar prompt de IA",
    "edit_popup": "Editar prompt de IA",
    "key": "Clave del slot",
    "model": "Modelo",
    "updated_at": "Actualizado",
    "custom": "Personalizado",
    "description": "Descripción",
    "temperature": "Temperature",
    "top_p": "Top P",
    "reasoning_effort": "Esfuerzo de razonamiento",
    "reasoning_effort_default": "Predeterminado",
    "required_placeholders": "Marcadores de posición obligatorios (deben estar presentes en el contenido)",
    "versions": "Historial de versiones",
    "no_versions": "Aún no hay versiones",
    "restore": "Restaurar",
    "restore_confirm": "¿Restaurar esta versión? Su contenido pasará a ser el actual.",
    "restored": "Versión restaurada",
    "current_version": "Actual",
    "author": "Autor",
    "error": "Algo salió mal.",
    "tab_system": "Sistema",
    "tab_custom": "Personalizado",
    "system_hint": "Los prompts del sistema los utiliza el código de la plataforma. No se pueden eliminar, pero su contenido sí se puede editar.",
    "custom_hint": "Los prompts personalizados se asocian a competencias y perfiles de IA como sustitución del prompt de evaluación.",
    "model_from_code": "definido por el código",
    "model_from_code_hint": "El modelo lo elige el código que consume el prompt; no se almacena en el propio prompt.",
    "used_by": "Usado por",
    "used_by_value": "Competencias: {competencies}, Perfiles de IA: {profiles}",
    "not_used": "Sin uso",
    "delete_blocked_hint": "No se puede eliminar: el prompt se usa como sustitución. {usage}",
    "slot_description": {
      "game_eval_negotiation": "Evaluación por IA de sesiones PvP: negociación",
      "game_eval_feedback": "Evaluación por IA de sesiones PvP: retroalimentación",
      "game_eval_vs_ai": "Evaluación por IA de sesiones contra IA (cuando el perfil de IA no tiene sustitución)",
      "protocol_evaluation": "Completar el protocolo del escenario a partir de la transcripción de una sesión contra IA",
      "voice_agent": "Prompt del sistema para el agente de voz de IA",
      "scenario_generation": "Generación del escenario a partir de la descripción",
      "scenario_card_update": "Actualización de la tarjeta del escenario a partir de la descripción de la IA",
      "scenario_optimize": "Optimización de la descripción de la IA de un escenario",
      "skill_report_analysis": "Informe de habilidades: paso de análisis",
      "skill_report_recommendations": "Informe de habilidades: paso de recomendaciones"
    }
  },
  "ai-profiles-page": {
    "name": "Nombre",
    "settings": "Configuración",
    "temperature": "Fantasía",
    "demeanor": "Comportamiento",
    "behavior": "Comportamiento, instrucciones",
    "background": "Biografía",
    "style": "Estilo",
    "instructions": "Instrucciones",
    "supportive_phrases": "Frases de apoyo",
    "ai_assistant": "Asistente de IA",
    "ai_starts_first": "La IA comienza primero",
    "first_phrase": "Primera frase",
    "closing_phrases": "Frases de cierre",
    "voice": "Voz",
    "expert_mode": "Modo experto",
    "custom_demeanor_hint": "Comportamiento personalizado actual",
    "is_shared": "Disponible para todas las organizaciones",
    "voice_options": {
      "male": "Masculino",
      "female": "Femenino"
    },
    "demeanor_options": {
      "friendly": {
        "title": "Amigable",
        "description": "Fácilmente accesible y agradable"
      },
      "critical": {
        "title": "Crítico",
        "description": "Frecuentemente señala defectos y áreas de mejora"
      },
      "empathetic": {
        "title": "Empático",
        "description": "Muy sensible a los sentimientos y emociones de otros"
      },
      "enthusiastic": {
        "title": "Entusiasta",
        "description": "Muestra intensa emoción y entusiasmo"
      },
      "analytical": {
        "title": "Analítico",
        "description": "Se enfoca en la lógica y resolución detallada de problemas"
      },
      "curious": {
        "title": "Curioso",
        "description": "Ansioso por aprender y hacer preguntas"
      },
      "assertive": {
        "title": "Asertivo",
        "description": "Confiado y seguro de sí mismo"
      },
      "blunt": {
        "title": "Directo",
        "description": "Directo y al grano"
      },
      "skeptical": {
        "title": "Escéptico",
        "description": "Cauteloso con nuevas soluciones e ideas"
      },
      "neutral": {
        "title": "Neutral",
        "description": "Equilibrado y objetivo en el estilo de comunicación"
      },
      "casual": {
        "title": "Casual",
        "description": "Relajado y conversacional en el tono"
      }
    },
    "placeholders": {
      "name": "Por ejemplo: Sergey (educado y amigable)",
      "demeanor": "Por ejemplo: Amigable, educado y sociable...",
      "background": "Por ejemplo: Fue despedido dos veces...",
      "behavior": "Por ejemplo: No interrumpe, escucha activamente...",
      "first_phrase": "Por ejemplo: ¡Buen día! ¿Cómo está su ánimo?",
      "closing_phrases": "Por ejemplo: Ya casi no nos queda tiempo, así que propongo resumir rápidamente nuestra reunión."
    },
    "actions": " ",
    "add": "Añadir perfil de IA",
    "add_popup": "Añadir perfil de IA",
    "subtitle": "Cómo se ve y suena el interlocutor en la sesión",
    "preview": {
      "title": "Vista previa",
      "unnamed": "Sin nombre",
      "voice": "voz {name}",
      "defaultVoice": "voz predeterminada",
      "defaultPhoto": "Foto predeterminada",
      "listen": "Escuchar la voz",
      "defaultVoiceNotice": "La voz se elegirá al iniciar la sesión; no se puede escuchar de antemano",
      "photoPlaceholder": "La foto aparecerá aquí"
    },
    "delete": "Eliminar perfil de IA",
    "edit": "Editar perfil de IA",
    "edit_popup": "Editar perfil de IA",
    "avatar_hint": "imagen de avatar",
    "avatar_save_first": "Guarda primero el perfil para habilitar la subida de avatares",
    "avatar_requirements": "Máx. 1 MB • Recomendado: 1536×1024 • Relación de aspecto: 3:2",
    "max_characters": "Máx. {max} caracteres"
  },
  "games-page": {
    "game-with-ai": "Sesión con IA",
    "organization": "Organización",
    "status": "Estado",
    "failure_reasons": {
      "protocol_not_agreed": "Los participantes no acordaron el protocolo de evaluación",
      "protocol_approval_expired": "El tiempo de aprobación del protocolo ha expirado",
      "annulled": "La sesión fue anulada por un administrador",
      "expired": "El tiempo de la sesión expiró",
      "assignment_changed": "La asignación del curso cambió en el sistema de aprendizaje"
    },
    "restore": "Restaurar",
    "play": "Jugar",
    "meetings_unavailable": "Las sesiones de vídeo entre participantes no están disponibles temporalmente. Inténtalo de nuevo más tarde.",
    "import": "Importar",
    "scenario": "Escenario",
    "tour": "Jornada",
    "game_types": {
      "classic": "Modo clásico",
      "vs_ai": "Sesión vs IA",
      "uploaded_recording": "Grabación"
    },
    "upload_recording": {
      "file": "Archivo de la grabación",
      "file_hint": "Video o audio, hasta 1 GB",
      "uploaded": "Archivo subido",
      "file_too_large": "El archivo supera 1 GB",
      "upload_error": "No se pudo subir el archivo",
      "player": "Participante",
      "rate_both": "Evaluar a ambos participantes",
      "second_player": "Segundo participante",
      "open_session": "Abrir la sesión"
    },
    "game_targets": {
      "user": "Participante",
      "position": "Puesto",
      "department": "Departamento"
    },
    "number": "Número",
    "start_up_to": "Comenzar hasta",
    "start_time": "Hora de inicio",
    "teamA": "Equipo A",
    "teamB": "Equipo B",
    "others": "Participantes",
    "actions": " ",
    "edit_results": "Cambiar resultados",
    "add": "Añadir sesión",
    "add_popup": "Añadir sesión",
    "delete": "Eliminar sesión",
    "edit": "Editar sesión",
    "edit_popup": "Editar sesión",
    "time_scheduling": "Programación de la hora de inicio",
    "return_to_time_scheduling": "Volver a la programación de la hora de inicio",
    "preparation": "Preparación para la sesión",
    "view_scenario": "Ver escenario",
    "protocol": "Aprobación del protocolo",
    "not_agreed": "No acordado",
    "expert-accept": "Aceptar y proceder a la evaluación",
    "expert-decline": "Rechazar",
    "hide_ai_results": "Ocultar evaluación AI",
    "show_ai_results": "Mostrar evaluación AI",
    "mark_failed": "Marcar como fallida",
    "popup": {
      "start_up_to": "Comenzar hasta",
      "target": "¿A quién se debe asignar la sesión?",
      "custom_field_value": "Valor de «{field}»",
      "target_preview_count": "Sesiones que se crearán: {count}",
      "target_preview_empty": "Ningún jugador coincide con este segmento: no se creará ninguna sesión",
      "target_preview_limit_exceeded": "Es más de lo que se puede crear en una asignación (máximo {limit}). Reduzca el segmento, el número de casos o el número de copias",
      "copies_per_player": "Copias de cada caso por jugador",
      "position": "Puesto",
      "department": "Departamento",
      "scenario": "Escenario",
      "optional": "Opcional, se puede omitir",
      "protocol_time": "Tiempo de protocolo",
      "protocol_time_hint": "Número entre 1 y 1440",
      "preparation_time": "Tiempo de preparación",
      "preparation_time_hint": "En minutos",
      "game_duration": "Duración de la sesión",
      "game_duration_hint": "Número entre 1 y 60",
      "is_team": "Escenario para equipos",
      "is_camera_required": "Se requieren cámaras de los participantes",
      "is_self_rated": "Los participantes pueden calificarse a sí mismos",
      "is_each_other_rated": "Los participantes pueden calificarse entre sí",
      "is_expert_rated": "La calificación del experto está disponible",
      "is_ai_rated": "La calificación de la IA está disponible",
      "show_results": "Mostrar resultados",
      "automatically": "automáticamente",
      "manually": "manualmente",
      "is_public_hint": "Cualquier observador podrá conectarse",
      "is_public": "Sesión pública",
      "team_a": "Equipo A",
      "team_b": "Equipo B",
      "player_a": "Participante A",
      "player_b": "Participante B",
      "expert": "Experto",
      "observers": "Observadores",
      "tour": "Jornada",
      "search": "Buscar...",
      "choose_players": "Elegir participantes",
      "choose_expert": "Elegir experto",
      "choose_observers": "Elegir observadores",
      "choose_scenario": "Elegir escenario",
      "choose_tour": "Elegir jornada",
      "expert_empty": "Si no se selecciona, el capitán podrá elegir",
      "captain": "Capitán",
      "": "",
      "protocol": {
        "title": "Aprobación del protocolo",
        "target": "Objetivo",
        "await_approval": "Esperar la aprobación del oponente",
        "await_proposal": "Esperar la propuesta del oponente",
        "questions": "Preguntas para tu equipo",
        "questions_a": "Preguntas para el equipo A",
        "questions_b": "Preguntas para el equipo B",
        "not_agreed": "No llegaron a un acuerdo",
        "not_agreed_confirm": "La sesión terminará sin éxito y los resultados no serán contabilizados. Esta acción es irreversible.",
        "not_agreed_done": "La sesión ha terminado sin éxito."
      },
      "start_time": {
        "title": "Hora de inicio",
        "must_start_by": "Debe comenzar antes de"
      },
      "edit_results": {
        "title": "Cambiar resultados"
      },
      "preparation": {
        "title": "Preparación para la sesión",
        "description": "Descripción",
        "description_team": "Descripción del equipo",
        "notes": "Notas personales"
      },
      "import": {
        "download_example": "Descargar ejemplo",
        "title": "Importación de sesiones",
        "button": "Iniciar importación",
        "label": "Archivo Excel"
      },
      "create_multi_scenario_games_immediately": "Todas las sesiones se crearán inmediatamente",
      "create_multi_scenario_games_sequentially": "Las sesiones se crearán secuencialmente (después de completar exitosamente cada una)"
    }
  },
  "ai-game": {
    "title": "Sesión vs IA",
    "recording": "Grabando",
    "ai": "IA",
    "you": "Tú",
    "ai_ready": "Listo",
    "camera_off": "Cámara apagada",
    "stop_game": "Detener sesión",
    "start_game": "Iniciar sesión",
    "mic_permission": "Por favor, concede permisos de micrófono en la configuración para iniciar la sesión",
    "permissions_granted": "¡Permisos concedidos con éxito!",
    "close": "Cerrar",
    "microphone_required": "Please grant microphone permissions to start the session",
    "mic_required": "Enciende el micrófono para iniciar la sesión",
    "mic_not_detected": "Aún no se detecta sonido — intente hablar o compruebe su micrófono",
    "permissions_needed": "El acceso al micrófono es obligatorio. La cámara es opcional",
    "agent": {
      "initializing": "Initializing...",
      "listening": "Listening",
      "thinking": "Thinking...",
      "speaking": "Speaking",
      "waiting": "Waiting for agent..."
    },
    "waiting_for_start": "Start the session to begin conversation",
    "grant_microphone": "Grant Microphone Access",
    "game_not_found": "Session Not Found",
    "game_not_found_desc": "Session with ID {id} could not be located.",
    "confirm": {
      "start_question": "¿Estás seguro? La sesión no se puede pausar",
      "start_title": "Sesión Iniciada",
      "start_success": "La sesión se ha iniciado con éxito",
      "start_cancel_title": "Sesión No Iniciada",
      "start_cancel_msg": "Se canceló el inicio de la sesión",
      "end_question": "¿Estás seguro? La sesión terminará",
      "end_title": "Sesión Terminada",
      "end_success": "La sesión ha terminado con éxito",
      "end_cancel_title": "Sesión No Terminada",
      "end_cancel_msg": "Se canceló el final de la sesión"
    },
    "voice": {
      "disconnected": "Desconectado",
      "connecting": "Conectando...",
      "connected": "Conectado al servidor",
      "connection_error": "Error al conectar con el agente de voz",
      "game_already_finished": "Esta partida ya ha terminado",
      "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
      "no_rooms_available": "No hay salas disponibles en este momento. Por favor, inténtelo más tarde.",
      "preparing_recording": "Preparando la grabación, reintentando en {seconds}s…",
      "recording_service_overloaded": "El servicio de grabación está sobrecargado. Por favor, inténtelo de nuevo en unos minutos.",
      "session_quota_exhausted": "El paquete de sesiones de su organización está agotado. Por favor, consulte a su gerente.",
      "connection_blocked": "Tu red bloqueó el establecimiento de conexión con la IA. Permite HTTPS (443) hacia los dominios necesarios y vuelve a intentarlo.",
      "connection_blocked_signaling": "El firewall o proxy de tu red está bloqueando la conexión al servidor de voz. Intenta conectarte desde otra red o un hotspot móvil.",
      "reconnecting": "Reconnecting...",
      "disconnect_dialog_title": "Connection Lost",
      "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
      "disconnect_retry": "Reconnect",
      "disconnect_finish": "Finish Session",
      "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
      "stop_failed": "Failed to stop the session",
      "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
      "mic_toggle_failed": "Failed to toggle microphone",
      "camera_toggle_failed": "Failed to toggle camera",
      "duplicate_tab_title": "Session Open in Another Tab",
      "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
      "duplicate_tab_back": "Go Back",
      "duplicate_tab_disconnect_title": "Opened in Another Tab",
      "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
    },
    "permissions_denied_safari": "Se denegó el acceso a la cámara o micrófono. Ve a Configuración de Safari > Sitios web > Cámara/Micrófono y permite el acceso para este sitio.",
    "supported": "Navegador compatible"
  },
  "positions-page": {
    "title": "Título",
    "actions": " ",
    "add": "Añadir puesto",
    "add_popup": "Añadir puesto",
    "delete": "Eliminar puesto",
    "edit": "Editar puesto",
    "edit_popup": "Editar puesto"
  },
  "user-custom-fields-page": {
    "title": "Título",
    "type": "Tipo",
    "options_count": "Valores",
    "actions": " ",
    "add": "Añadir campo",
    "add_popup": "Añadir campo",
    "delete": "Eliminar campo",
    "delete_confirm": "¿Eliminar el campo? Los valores guardados en los usuarios dejarán de mostrarse.",
    "edit": "Editar campo",
    "edit_popup": "Editar campo",
    "empty": "Todavía no hay campos personalizados",
    "error": "No se ha podido guardar el campo",
    "type_text": "Texto",
    "type_select": "Lista",
    "type_locked_hint": "El tipo no se puede cambiar una vez creado el campo",
    "options": "Valores",
    "options_hint": "El orden de los valores aquí es el orden en la lista desplegable",
    "options_required": "Añade al menos un valor",
    "option_title": "Valor",
    "option_add": "Añadir valor",
    "option_delete": "Eliminar valor",
    "option_delete_confirm": "¿Eliminar el valor? Se borrará en los usuarios que lo tuvieran seleccionado.",
    "option_move_up": "Mover arriba",
    "option_move_down": "Mover abajo"
  },
  "organizations-page": {
    "name": "Nombre",
    "host": "Anfitrión",
    "duel_limit": "Límite de duelos",
    "max_users": "Máx. usuarios",
    "max_users_hint": "0 = ilimitado",
    "max_vs_ai_games_per_scenario": "Máx. partidas IA por jugador y escenario",
    "max_vs_ai_games_per_scenario_hint": "Vacío = sin límite. Se aplica a la creación de partidas por iniciativa propia del jugador",
    "employee_report_daily_limit": "Límite de informes de empleados al día",
    "employee_report_daily_limit_hint": "Vacío = límite general de la plataforma. Se aplica a administradores y responsables",
    "employee_report_hourly_limit": "Límite de informes de empleados por hora",
    "employee_report_hourly_limit_hint": "Vacío = límite general de la plataforma. Se aplica a administradores y responsables",
    "registration": "Registro abierto",
    "timezone": "Zona horaria",
    "locale": "Idioma",
    "users_count": "Usuarios",
    "actions": " ",
    "add": "Añadir organización",
    "add_popup": "Añadir organización",
    "delete": "Eliminar organización",
    "edit": "Editar organización",
    "edit_popup": "Editar organización",
    "available_languages": "Idiomas disponibles",
    "show_game_numbers_for_player": "Mostrar números de sesión para el participante",
    "allow_players_choose_expert": "Permitir a los participantes elegir experto",
    "send_message": "Enviar mensaje a los gerentes",
    "message": "Mensaje",
    "send": "Enviar",
    "clear_message": "Borrar mensaje",
    "current_message": "Mensaje actual",
    "two_factor_method": "Autenticación de dos factores",
    "two_factor_disabled": "Desactivada",
    "two_factor_email": "Correo electrónico",
    "two_factor_sms": "SMS",
    "hidden_menu_items": "Hidden menu items",
    "hide_ai_results": "Ocultar resultados de IA",
    "hide_player_rating": "Ocultar la clasificación de la empresa a los participantes",
    "show_character_memory_to_player": "Mostrar la memoria del personaje al jugador",
    "show_meeting_recap_to_player": "Mostrar el resumen de la reunión al jugador",
    "create_user_on_external_launch": "Crear un usuario en la primera solicitud de un sistema externo",
    "create_user_on_external_launch_hint": "Si está desactivada, un alumno al que el sistema externo nunca ha traído antes recibe un rechazo en lugar de una partida. Cada usuario creado de esta forma ocupa una plaza en la suscripción.",
    "allow_external_email_linking": "Permitir vincular un usuario externo por correo electrónico",
    "allow_external_email_linking_hint": "Si está activada, una persona externa se vincula a un empleado ya existente cuando el sistema externo informa su correo electrónico desde su propio servidor. Si está desactivada, ese inicio se rechaza y no se crea un segundo usuario con esa dirección."
  },
  "users-page": {
    "import": "Importar",
    "user": "Usuario",
    "roles": "Roles",
    "effectiveness": "Efectividad",
    "department": "Departamento",
    "position": "Puesto",
    "status": "Estado",
    "actions": " ",
    "add": "Añadir usuario",
    "add_popup": "Nuevo usuario",
    "last_login_at": "Último acceso",
    "delete": "Eliminar",
    "view": "Ver",
    "login": "Iniciar sesión",
    "message": "Mensaje",
    "activate": "Activar",
    "deactivate": "Bloquear",
    "edit_popup": "Editar usuario",
    "total_in_org": "Total en la organización",
    "multi_role_note": "Un usuario con varios roles se cuenta en cada insignia",
    "filter_role": "Rol",
    "all_roles": "Todos los roles",
    "filter_activity": "Escenarios completados",
    "activity_played": "Sí",
    "activity_not_played": "No",
    "filter_activity_from": "Jugado desde",
    "filter_last_login_from": "Fecha de acceso",
    "filter_custom_field": "Campo personalizado",
    "filter_custom_field_value": "Valor de «{field}»",
    "last_login_never": "Nunca ha iniciado sesión",
    "last_login_since": "Ha iniciado sesión desde",
    "cases_progress": "Casos completados",
    "cases_progress_value": "{completed} de {assigned}",
    "export": "Exportar",
    "popup": {
      "name": "Nombre",
      "last_name": "Apellidos",
      "patronymic": "Patronímico",
      "phone": "Teléfono",
      "timezone": "Zona horaria",
      "language": "Idioma",
      "country": "País",
      "invalid_phone": "Número de teléfono incorrecto",
      "department": "Departamento",
      "position": "Puesto",
      "effectiveness": "Efectividad",
      "roles": "Roles",
      "organizations": "Organizaciones",
      "blocked": "Bloqueado",
      "is_active": "Está activo",
      "email_verified": "El correo electrónico está verificado",
      "email_not_verified": "El correo electrónico no está verificado",
      "subordinates": "Subordinados",
      "search_subordinates": "Buscar participantes...",
      "import": {
        "download_example": "Descargar ejemplo",
        "title": "Importación de usuarios",
        "button": "Iniciar importación",
        "label": "Archivo Excel",
        "marker_hint": "Para un usuario que ya existe, una celda vacía mantiene el valor actual y un guion (-) borra el campo.",
        "result_title": "Importación iniciada",
        "result_created": "Se crearán: {count}",
        "result_updated": "Se actualizarán: {count}",
        "result_skipped": "Omitidas: {count}",
        "result_skipped_row": "Fila {row}, {email}: {reason}",
        "result_truncated": "…y {count} filas omitidas más"
      }
    }
  },
  "users-ranking-page": {
    "user": "Usuario",
    "roles": "Roles",
    "effectiveness": "Efectividad",
    "average-effectiveness": "Promedio por sesión",
    "sessions-count": "Sesiones",
    "department": "Departamento",
    "position": "Puesto",
    "status": "Estado",
    "export": "Exportar",
    "actions": " "
  },
  "user-detail": {
    "games_finished": "Sesiones Finalizadas",
    "not_found": "Usuario no encontrado",
    "games_total": "Total",
    "username": "Nombre de usuario",
    "phone": "Teléfono",
    "status": "Estado",
    "language": "Idioma",
    "timezone": "Zona horaria",
    "edit": "Editar",
    "department": "Departamento",
    "position": "Puesto",
    "activate": "Activar",
    "block": "Bloquear",
    "account": {
      "title": "Cuenta",
      "summary": {
        "title": "Resumen",
        "games": "Sesiones jugadas",
        "place": "Lugar",
        "effectiveness": "Efectividad",
        "time": "Tiempo"
      }
    },
    "security": {
      "title": "Seguridad",
      "change_password_title": "Cambiar contraseña",
      "change_password": "Cambiar contraseña",
      "new_password": "Nueva contraseña",
      "confirm_new_password": "Confirmar nueva contraseña",
      "password_requirements": "Requisitos de la contraseña:",
      "password_requirements_1": "Mínimo 8 caracteres de largo - cuantos más, mejor",
      "password_requirements_2": "Al menos un carácter en minúscula",
      "password_requirements_3": "Al menos un número, símbolo o carácter de espacio en blanco"
    },
    "statistics": {
      "title": "Estadísticas"
    }
  },
  "game": {
    "character_memory": {
      "title": "Lo que el personaje recuerda",
      "subtitle": "La memoria de reuniones anteriores con la que el personaje llega a esta partida",
      "preview_subtitle": "La memoria aún no se ha registrado: el personaje la recibirá en el momento en que comience la partida",
      "unavailable": "La reunión anterior no está disponible para el personaje: iniciará la conversación sin recordarla.",
      "agreements": "Acuerdos",
      "player_commitments": "Compromisos del jugador",
      "character_commitments": "Compromisos del personaje",
      "open_issues": "Cuestiones pendientes",
      "facts": "Datos mencionados",
      "attitude": "Actitud hacia el jugador",
      "evaluation_passed": "Se han transmitido al personaje los resultados de la evaluación de aquella reunión",
      "evaluation_not_ready": "La evaluación de aquella reunión aún no está lista: el personaje la recibirá en cuanto se calcule.",
      "evaluation_hidden": "Los textos de la evaluación están ocultos por la configuración de la organización.",
      "overall_effectiveness": "Eficacia general",
      "outcome": {
        "deal": "Acuerdo",
        "partial": "Parcial",
        "no_deal": "Sin acuerdo",
        "unclear": "Poco claro"
      }
    },
    "meeting_recap": {
      "title": "Resumen de la reunión",
      "outcome": "Resultado de la reunión",
      "agreements": "Acuerdos",
      "player_commitments": "Compromisos del jugador",
      "character_commitments": "Compromisos del personaje",
      "open_issues": "Cuestiones pendientes",
      "facts": "Datos mencionados",
      "pending": "El resumen de la reunión todavía se está preparando. Vuelva a consultarlo un poco más tarde.",
      "unavailable": "No se ha podido generar el resumen de esta reunión.",
      "none": "No hay resumen para esta partida."
    },
    "title": "Sesión",
    "team": "Equipo",
    "expert": "Experto",
    "points": "puntos",
    "your_result": "Tu resultado",
    "joined_at": "Se unió:",
    "ended_at": "Fecha de finalización",
    "min": "min.",
    "duration": "Duración",
    "from_average": "del promedio",
    "ai_expert": "Experto de IA",
    "ai_evaluation_in_progress": "Evaluación de IA en curso",
    "delete_ai_request": "Eliminar retroalimentación de IA",
    "ai_expert_refresh": "Actualizar Resultados de IA",
    "ai_expert_refresh_rejected": {
      "evaluation_not_completed": "Ahora mismo no se pueden actualizar los resultados de IA: la evaluación de IA todavía está en curso.",
      "answer_pending": "Ahora mismo no se pueden actualizar los resultados de IA: la respuesta de la IA aún no ha llegado.",
      "recognition_pending": "Ahora mismo no se pueden actualizar los resultados de IA: la grabación todavía se está transcribiendo.",
      "recognition_has_no_speech": "No se ha reconocido voz en la grabación, por lo que no se pueden actualizar los resultados de IA.",
      "recognition_has_too_little_speech": "En la grabación casi no hay conversación entre los participantes, por lo que no se realizó la evaluación de IA.",
      "no_ai_evaluation": "Esta sesión ya no tiene evaluación de IA.",
      "game_evaluation_blocked": "La sesión no se celebró o fue anulada, por lo que la evaluación de IA no está disponible."
    },
    "ai_expert_unavailable": {
      "recognition_has_no_speech": "No se ha reconocido voz en la grabación, por lo que no se realizó la evaluación de IA.",
      "recognition_has_too_little_speech": "En la grabación casi no hay conversación entre los participantes, por lo que no se realizó la evaluación de IA.",
      "game_evaluation_blocked": "La sesión no se celebró o fue anulada, por lo que la evaluación de IA no está disponible."
    },
    "ai_expert_refresh_failed": "No se pudieron actualizar los resultados de IA.",
    "speaker_mapping": {
      "title": "Participantes y voces",
      "voice": "Voz {number}",
      "unknown": "No identificado",
      "needs_review": "Revisa los participantes",
      "needs_review_hint": "Es posible que los participantes se hayan identificado incorrectamente: asegúrate de que la retroalimentación de IA llegó a las personas correctas.",
      "failed": "No se pudo identificar automáticamente a los participantes.",
      "unavailable": "El proveedor de IA no estaba disponible; los participantes se identificarán en la próxima evaluación.",
      "empty": "La transcripción no tiene intervenciones a partir de las cuales identificar a los participantes.",
      "corrected_manually": "Corregido manualmente",
      "under_reevaluation": "La evaluación de IA está en curso con estos participantes. Hasta que termine, la página muestra los resultados anteriores.",
      "confirm": "Los participantes son correctos",
      "review": "Revisar",
      "dialog_hint": "Asigna un participante a cada voz. Después de guardar, se volverá a solicitar la retroalimentación de IA.",
      "save": "Guardar",
      "cancel": "Cancelar",
      "confirmed": "Participantes confirmados",
      "fixed": "Participantes corregidos, retroalimentación de IA solicitada de nuevo",
      "action_failed": "No se pudo completar la acción"
    },
    "ai_expert_created": "El proceso de calificación de la sesión ha comenzado. Esto tomará unos minutos. Puedes abandonar la página, ya que te enviaremos una notificación cuando la calificación esté disponible.",
    "expert_already_requested": "La calificación ya ha sido solicitada por otro participante",
    "request_expert": "Solicitar Experto",
    "assign_expert": "Asignar Experto",
    "ai_process": "Por favor espera, procesando",
    "analyzing_results": "Analizando resultados de la sesión...",
    "complete_expert_request": "Completar evaluación",
    "tabs": {
      "description": {
        "title": "Descripción del Escenario",
        "subtitle": "Información y reglas de la sesión",
        "situation": "Situación",
        "your_role": "Tu rol",
        "player_role": "Rol del jugador: {name}",
        "team_tab": "Equipo {team}",
        "empty": "Esta sesión no tiene descripciones.",
        "load_error": "No se pudo cargar la descripción. Inténtalo de nuevo más tarde."
      },
      "results": {
        "title": "Resultados",
        "effectiveness_summary": "Efectividad del equipo",
        "your_effectiveness": "Tu efectividad",
        "parameters_section": "Parámetros",
        "parameter": "Parámetro",
        "target": "Objetivo",
        "coefficient": "Coeficiente",
        "value": "Acuerdo",
        "points": "Puntos",
        "points_short": "puntos",
        "combinations": "Combinaciones",
        "combination_bonus": "Bono de combinación",
        "questions": "Preguntas",
        "question": "Pregunta",
        "answer": "Respuesta",
        "total": "Total"
      },
      "comments": {
        "title": "Análisis de Video",
        "comments": "Comentarios",
        "no_comments": "Aún no hay comentarios",
        "no_video": "Video no disponible",
        "video_processing": "El video se está procesando...",
        "count": "comentarios",
        "delete": "Eliminar",
        "edit": "Editar",
        "popup": {
          "add": "Añadir comentario",
          "edit": "Editar comentario",
          "comment": "Comentario",
          "player": "Participante",
          "all": "A todos"
        }
      },
      "feedback": {
        "title": "Evaluación de la Sesión",
        "no_feedback": "Aún no hay calificaciones",
        "no_feedback_description": "Aún no se ha agregado retroalimentación para esta sesión",
        "overall_score": "Puntuación General",
        "skills_evaluated": "{count} habilidades evaluadas",
        "no_comment": "Sin comentario",
        "score_button": "Calificar Participante",
        "player": "Participante",
        "author": "Autor",
        "download": "Descargar video",
        "download_transcript": "Descargar transcripción",
        "evaluators": {
          "ai": "Experto",
          "expert": "Experto",
          "player": "Participante",
          "manager": "Administrador",
          "head": "Responsable"
        },
        "popup": {
          "score": {
            "title": "Evaluación del Participante",
            "comment": "Comentario",
            "error": "Debes evaluar todas las habilidades del participante",
            "save_error": "No se pudo guardar la evaluación. Es posible que no tengas permiso para evaluar a este participante."
          }
        }
      },
      "checklist": {
        "title": "Lista de verificación",
        "total": "Ítems aprobados",
        "pass": "Cumple",
        "fail": "No cumple",
        "cannot_assess": "No evaluable",
        "comment": "Comentario general",
        "category": "Categoría",
        "author": "Evaluador",
        "player": "Participante",
        "passed_of": "{passed} de {total}",
        "evidence": "Evidencia",
        "rationale": "Justificación",
        "no_results": "Aún no hay evaluación de lista de verificación",
        "no_results_description": "Esta sesión aún no ha sido evaluada con una lista de verificación"
      }
    }
  },
  "scenario": {
    "steps": {
      "information": {
        "create_new_ai_profile": "Crear nuevo",
        "edit_ai_profile": "Editar",
        "delete_ai_profile": "Eliminar",
        "confirm_delete_ai_profile": "¿Está seguro de que desea eliminar este perfil de IA?",
        "first_header": "Configuración Básica",
        "second_header": "Participante IA",
        "third_header": "Descripción del Escenario",
        "is_public": "Público",
        "is_public_hint": "Si está habilitado — el escenario estará disponible para la selección por parte de los participantes.",
        "title": "Información",
        "subtitle": "Datos básicos del escenario",
        "image": "imagen del escenario",
        "field_title": "Título",
        "competence": "Competencia",
        "description": "Descripción",
        "description_a": "Descripción para el equipo A",
        "description_b": "Descripción para el equipo B",
        "next_scenario_label": "Siguiente Escenario",
        "next_scenario_placeholder": "No seleccionado",
        "next_scenario_hint": "Después de completar la sesión con este escenario, se creará automáticamente una sesión con el siguiente escenario.",
        "memory_header": "Conexión con la siguiente reunión",
        "memory_group_evaluation": "La evaluación de la siguiente reunión",
        "memory_group_character": "El personaje de la siguiente reunión",
        "memory_pass_to_next": "recuerda esta reunión",
        "memory_pass_to_next_hint": "El personaje del siguiente escenario iniciará la conversación como si ya conociera al jugador: recibirá un resumen breve de esta reunión, los acuerdos, los compromisos de ambas partes, las cuestiones pendientes y los datos mencionados. No se le transmite la grabación ni las citas textuales. Actívelo cuando la siguiente reunión continúe esta: una segunda ronda de negociación, una reunión periódica uno a uno.",
        "memory_pass_evaluation_to_next": "conoce la evaluación de esta reunión",
        "memory_pass_evaluation_to_next_hint": "Junto con la memoria, el personaje recibirá los textos de retroalimentación sobre las competencias y el resultado general de esta reunión, de modo que pueda actuar como un coach que recuerda lo que el jugador hizo bien.",
        "memory_evaluate_next_with_agreements": "tiene en cuenta los acuerdos de esta reunión",
        "memory_evaluate_next_with_agreements_hint": "Al evaluar la siguiente reunión, el experto en IA verá los acuerdos, los compromisos de ambas partes y las cuestiones pendientes de esta, y podrá comprobar si el jugador cumplió lo prometido. Las puntuaciones y los textos de la evaluación anterior no se transmiten, para que no influyan en la nueva puntuación.",
        "ai_profile": "Perfil de IA",
        "ai_profile_placeholder": "Solo para sesiones contra IA",
        "ai_description": "Descripción de la IA",
        "optimize_ai_description": "Optimize with AI",
        "optimizing_in_progress": "AI is optimizing the description. Please wait...",
        "optimize_error": "Failed to optimize the description. Please try again.",
        "ai_description_hint": "Escribir un prompt de IA eficaz requiere experiencia. Un prompt mal redactado puede provocar un comportamiento impredecible del escenario. Si no está seguro, use el botón «Optimizar con IA», pruebe la generación de escenarios o consulte a su gerente.",
        "knowledge_base_header": "Base de conocimientos",
        "knowledge_base_documents": "Documentos de la base de conocimientos",
        "knowledge_base_documents_hint": "Adjunte documentos para proporcionar contexto al jugador de IA",
        "knowledge_base_no_documents": "No hay documentos disponibles. Suba documentos en la página \"Base de conocimientos\".",
        "knowledge_base_chunks": "{count} fragmentos",
        "knowledge_base_purpose_voice": "Sesión de IA",
        "knowledge_base_purpose_eval": "Evaluación"
      },
      "settings": {
        "title": "Configuración",
        "subtitle": "Configuración del escenario",
        "min_players": "Mín. de participantes",
        "min_players_hint": "Número entre 2 y 20",
        "max_players": "Máx. de participantes",
        "max_players_hint": "Número entre 2 y 20",
        "protocol_time": "Tiempo de protocolo (min)",
        "protocol_time_hint": "Número entre 1 y 1440",
        "preparation_time": "Tiempo de preparación (min)",
        "preparation_time_hint": "Número entre 0 y 1440. 0 - la descripción es visible inmediatamente",
        "game_duration": "Duración de la sesión (min)",
        "game_duration_hint": "Número entre 1 y 60",
        "is_team": "Escenario para equipos",
        "is_camera_required": "Se requieren cámaras de los participantes",
        "is_self_rated": "Los participantes pueden calificarse a sí mismos",
        "is_each_other_rated": "Los participantes pueden calificarse entre sí",
        "is_expert_rated": "La calificación del experto está disponible",
        "is_ai_rated": "La calificación de la IA está disponible",
        "show_results": "Mostrar resultados",
        "automatically": "automáticamente",
        "manually": "manualmente"
      },
      "parameters": {
        "title": "Parámetros",
        "subtitle": "Parámetros del participante",
        "field_title": "Título",
        "team_a": "Equipo A",
        "team_b": "Equipo B",
        "player_a": "Participante A",
        "player_b": "Participante B",
        "points": "Puntos",
        "ratio": "Ratio",
        "add": "Añadir parámetro"
      },
      "questions": {
        "title": "Preguntas",
        "subtitle": "Preguntas para los participantes",
        "question": "Pregunta",
        "team": "Equipo",
        "team_placeholder": "Seleccionar Equipo",
        "answers": "Respuestas",
        "points": "Puntos",
        "select_answers": "Seleccionar respuestas",
        "add_combination": "Añadir combinación",
        "add_question": "Añadir pregunta"
      },
      "next": "Siguiente",
      "previous": "Anterior",
      "save": "Guardar"
    },
    "saved": "Escenario guardado",
    "to_list": "Volver a la lista",
    "add_detail": "Añadir escenario",
    "edit_detail": "Editar escenario"
  },
  "notifications": {
    "title": "Notificaciones",
    "mark_unread": "Marcar todo como no leído",
    "mark_read": "Marcar todo como leído",
    "delete_all": "Eliminar todo",
    "no_new": "No se encontraron notificaciones",
    "system": "Sistema",
    "evaluation": {
      "ready": {
        "subject": "Evaluación de la Sesión #:gameNumber",
        "text": "La sesión ha sido evaluada por un experto"
      }
    },
    "game": {
      "created": {
        "game_assigned": "Tienes una sesión asignada",
        "role": "Rol:"
      },
      "proposal": {
        "subject": "Coordinación de la hora de la sesión",
        "time": "Hora:",
        "description": "Por favor, confirma o propone tu propia opción"
      },
      "agreed": {
        "subject": "Hora de la sesión acordada",
        "time": "Hora:",
        "description": "La descripción y las opciones de preparación estarán disponibles :preparationTime minutos antes del inicio",
        "description_zero": "Ahora puedes revisar la descripción del escenario y prepararte"
      },
      "preparation": {
        "subject": "Preparación para la sesión",
        "text": "La preparación para la sesión está disponible."
      },
      "started": {
        "subject": "La sesión #:gameNumber ha comenzado",
        "text": "¡Únete!"
      },
      "missed": {
        "subject": "Te perdiste la sesión #:gameNumber",
        "text": "Lo sentimos, te perdiste la sesión"
      },
      "completed": {
        "subject": "Sesión #:gameNumber completada",
        "text": "Sesión exitosa"
      },
      "failed": {
        "subject": "Sesión #:gameNumber fallida",
        "text": "Completado sin éxito"
      },
      "results": {
        "proposed": {
          "subject": "Protocolo de la sesión #:gameNumber acordado",
          "text": "Acuerdo disponible"
        },
        "declined": {
          "subject": "Protocolo de la sesión #:gameNumber rechazado",
          "text": "Propuesta rechazada"
        },
        "not_agreed": {
          "subject": "Sesión #:gameNumber: las partes no llegaron a un acuerdo",
          "text": "El capitán rival indicó que las partes no llegaron a un acuerdo. La sesión terminó sin éxito y los resultados no fueron contabilizados."
        }
      },
      "meeting": {
        "ended-player": {
          "subject": "Reunión de la Sesión #:gameNumber Concluida",
          "text": "Por favor, espera los resultados."
        },
        "ended-captain": {
          "subject": "Reunión de la Sesión #:gameNumber Concluida",
          "text_fill": "Por favor, completa el protocolo.",
          "text_wait": "Por favor, espera a que se complete el protocolo.",
          "protocol_time": "Tiempo de protocolo (minutos): :protocolTime"
        }
      }
    }
  },
  "profile": {
    "avatar_allowed": "Permitido JPG, GIF o PNG. Tamaño máximo de 2MB",
    "avatar_label_choose": "Elige",
    "avatar_label_your_avatar": "tu avatar",
    "name": "Nombre",
    "last_name": "Apellidos",
    "patronymic": "Patronímico",
    "phone": "Teléfono",
    "timezone": "Zona horaria",
    "language": "Idioma",
    "country": "País",
    "invalid_phone": "Número de teléfono incorrecto",
    "save_changes": "Guardar cambios",
    "account": "Cuenta",
    "security": "Seguridad",
    "statistics": "Estadísticas",
    "notifications": "Notificaciones",
    "change_password_title": "Cambiar contraseña",
    "change_password": "Cambiar contraseña",
    "current_password": "Contraseña actual",
    "new_password": "Nueva contraseña",
    "confirm_new_password": "Confirmar nueva contraseña",
    "password_requirements": "Requisitos de la contraseña:",
    "password_requirements_1": "Mínimo 8 caracteres de largo - cuantos más, mejor",
    "password_requirements_2": "Al menos un carácter en minúscula",
    "password_requirements_3": "Al menos un número, símbolo o carácter de espacio en blanco",
    "two_factor_title": "Autenticación de dos factores",
    "two_factor_description": "Añada una capa extra de seguridad a su cuenta",
    "two_factor_org_enforced": "La autenticación de dos factores es obligatoria en su organización",
    "two_factor_method": "Método de autenticación",
    "two_factor_disabled": "Desactivada",
    "two_factor_email": "Correo electrónico",
    "two_factor_sms": "SMS",
    "two_factor_save": "Guardar configuración 2FA"
  },
  "auth": {
    "password": "Contraseña",
    "new_password": "Nueva contraseña",
    "remember": "Recuérdame",
    "timezone": "Zona horaria",
    "forgot": "¿Olvidaste la contraseña?",
    "login": "Iniciar sesión",
    "login_title": "Iniciar sesión",
    "new_password_title": "Cambiar contraseña",
    "change_password": "Guardar",
    "country": "País",
    "invalid_phone": "Número de teléfono incorrecto",
    "privacy_policy_title": "Política de Privacidad",
    "privacy_policy_text": "Texto de la política de privacidad...",
    "first_time": "¿Nuevo en nuestra plataforma?",
    "registration": "Crear una cuenta",
    "forgot_title": "¿Olvidaste la contraseña?",
    "forgot_description": "Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña",
    "send_reset_link": "Enviar enlace de restablecimiento",
    "back_to_login": "Volver a iniciar sesión",
    "register": "Registrarse",
    "name": "Nombre",
    "last_name": "Apellidos",
    "patronymic": "Patronímico",
    "phone": "Teléfono",
    "enter_password": "Ingresar Contraseña",
    "confirm_password": "Confirmar Contraseña",
    "not_first_time": "¿Ya tienes una cuenta?",
    "agree_too": "Acepto",
    "privacy_policy": "la política de privacidad y los términos",
    "accept": " Acepto ",
    "password_validation": "El campo debe contener al menos una mayúscula, una minúscula, un carácter especial y un dígito con un mínimo de 8 caracteres",
    "password_confirm_error": "La confirmación del campo Confirmar Contraseña no coincide",
    "set_password": "Establecer Nueva Contraseña",
    "reset_password": "Restablecer Contraseña",
    "for": "para",
    "sign_in_to_for": "Iniciar sesión en {app} para {org}",
    "registration_title": "Registro",
    "verify_title": "Confirmación de correo electrónico",
    "verify_head": "Verifica tu correo electrónico",
    "verify_description": "Se ha enviado un enlace de activación de cuenta a tu dirección de correo electrónico. Por favor, sigue el enlace para continuar.",
    "verify_new_link": "Se ha enviado un nuevo enlace de verificación a la dirección de correo electrónico que proporcionaste durante el registro.",
    "verify_send": "Reenviar correo de verificación",
    "verify_spam": "Has realizado demasiadas solicitudes, por favor, inténtalo de nuevo en un minuto.",
    "verify_logout": "Cerrar sesión",
    "two_factor_title": "Autenticación de dos factores",
    "two_factor_description_email": "Hemos enviado un código de verificación a su correo electrónico. Por favor, introduzca el código a continuación.",
    "two_factor_description_sms": "Hemos enviado un código de verificación a su número de teléfono. Por favor, introduzca el código a continuación.",
    "two_factor_code_label": "Código de verificación",
    "two_factor_code_placeholder": "Introduzca el código de 6 dígitos",
    "two_factor_verify": "Verificar",
    "two_factor_resend": "Reenviar código",
    "two_factor_resend_success": "Se ha enviado un nuevo código",
    "two_factor_back": "Volver al inicio de sesión"
  },
  "filepond": {
    "upload": "Subir",
    "upload_complete": "Subida completa",
    "uploading": "Subiendo",
    "loading": "Cargando",
    "tap_to_cancel": "toca para cancelar",
    "tap_to_undo": "toca para deshacer",
    "upload_aborted": "Subida cancelada",
    "file_too_large": "El archivo es demasiado grande"
  },
  "text-editor": {
    "image": "Simplemente arrastra y suelta tu imagen en el editor"
  },
  "webrtc": {
    "ready_to_start": "Listo para empezar",
    "connected": "Conectado - ¡Habla ahora!",
    "connection_lost": "Conexión perdida. Por favor, inténtalo de nuevo."
  },
  "device_settings": {
    "title": "Configuración de Dispositivos de Audio y Video",
    "speaker": "Altavoz/Salida de Audio",
    "refresh_devices": "Actualizar Dispositivos",
    "speaker_switch_unsupported": "El cambio de altavoz no es compatible con este navegador"
  },
  "device_setup": {
    "mic_level": "Nivel del micrófono",
    "mic_on": "Enc",
    "mic_off": "Apag",
    "cam_on": "Enc",
    "cam_off": "Apag"
  },
  "device_test": {
    "title": "Probar Dispositivos de Audio",
    "speaker_test": "Prueba de Altavoz",
    "speaker_hint": "Haz clic en el botón para reproducir sonidos de prueba a través del altavoz seleccionado",
    "play_sound": "Reproducir Sonido",
    "playing": "Reproduciendo...",
    "speaker_success": "Sonido Reproducido ✓",
    "mic_test": "Prueba de Micrófono",
    "mic_hint": "Haz clic en el botón y habla por el micrófono para comprobar si funciona",
    "volume_level": "Nivel de Volumen",
    "speak_now": "Habla ahora...",
    "seconds_short": "s",
    "start_mic_test": "Probar Micrófono",
    "testing": "Probando...",
    "test_again": "Probar de Nuevo",
    "mic_success": "¡El micrófono funciona correctamente!",
    "mic_fail": "Problema con el micrófono detectado",
    "mic_fail_hint": "No se detectó sonido. Verifica que el micrófono esté conectado, no silenciado y seleccionado correctamente en la configuración."
  },
  "ai_assistant_types": {
    "type": "Tipo",
    "negotiation": "Negociación",
    "feedback": "Retroalimentación",
    "ai_profile": "Sesión con IA"
  },
  "Login": "Iniciar sesión",
  "UI Elements": "Elementos de UI",
  "Forms & Tables": "Formularios y Tablas",
  "Welcome": "Bienvenido",
  "Pages": "Páginas",
  "Charts & Maps": "Gráficos y Mapas",
  "Others": "Otros",
  "Typography": "Tipografía",
  "Cards": "Tarjetas",
  "Basic": "Básico",
  "Advance": "Avanzado",
  "Widgets": "Widgets",
  "Components": "Componentes",
  "Alert": "Alerta",
  "Close Alert": "Cerrar Alerta",
  "Avatar": "Avatar",
  "Badge": "Insignia",
  "Button": "Botón",
  "Calendar": "Calendario",
  "Image": "Imagen",
  "Pagination": "Paginación",
  "Progress Circular": "Progreso Circular",
  "Progress Linear": "Progreso Lineal",
  "Autocomplete": "Autocompletar",
  "Tooltip": "Tooltip",
  "Slider": "Deslizador",
  "Date Time Picker": "Selector de Fecha y Hora",
  "Select": "Seleccionar",
  "Switch": "Interruptor",
  "Checkbox": "Casilla de verificación",
  "Radio": "Radio",
  "Textarea": "Área de texto",
  "Rating": "Calificación",
  "File Input": "Entrada de archivo",
  "Otp Input": "Entrada OTP",
  "Form Layout": "Diseño de Formulario",
  "Form Validation": "Validación de Formulario",
  "Charts": "Gráficos",
  "Apex Chart": "Gráfico Apex",
  "Chartjs": "Chartjs",
  "Account Settings": "Configuración de la Cuenta",
  "User Profile": "Perfil de Usuario",
  "FAQ": "Preguntas Frecuentes",
  "Dialog Examples": "Ejemplos de Diálogo",
  "Pricing": "Precios",
  "List": "Lista",
  "Edit": "Editar",
  "Nav Levels": "Niveles de Navegación",
  "Level 2.1": "Nivel 2.1",
  "Level 2.2": "Nivel 2.2",
  "Level 3.1": "Nivel 3.1",
  "Level 3.2": "Nivel 3.2",
  "Raise Support": "Solicitar Soporte",
  "Documentation": "Documentación",
  "Dashboards": "Paneles",
  "Analytics": "Analíticas",
  "Apps & Pages": "Aplicaciones y Páginas",
  "Email": "Correo electrónico",
  "Chat": "Chat",
  "Invoice": "Factura",
  "Preview": "Vista previa",
  "Add": "Añadir",
  "User": "Usuario",
  "View": "Ver",
  "Login v1": "Iniciar sesión v1",
  "Login v2": "Iniciar sesión v2",
  "Register v1": "Registrarse v1",
  "Register v2": "Registrarse v2",
  "Register": "Registrarse",
  "Forget Password v1": "Olvidar Contraseña v1",
  "Forget Password v2": "Olvidar Contraseña v2",
  "Forgot Password v1": "Olvidé mi Contraseña v1",
  "Forgot Password v2": "Olvidé mi Contraseña v2",
  "Forgot Password": "Olvidé mi Contraseña",
  "Reset Password v1": "Restablecer Contraseña v1",
  "Reset Password v2": "Restablecer Contraseña v2",
  "Reset Password": "Restablecer Contraseña",
  "Miscellaneous": "Misceláneo",
  "Coming Soon": "Próximamente",
  "Not Authorized": "No Autorizado",
  "Under Maintenance": "En Mantenimiento",
  "Error": "Error",
  "Statistics": "Estadísticas",
  "Actions": "Acciones",
  "Access Control": "Control de Acceso",
  "User Interface": "Interfaz de Usuario",
  "CRM": "CRM",
  "eCommerce": "Comercio Electrónico",
  "Icons": "Iconos",
  "Chip": "Chip",
  "Dialog": "Diálogo",
  "Expansion Panel": "Panel de Expansión",
  "Combobox": "Combobox",
  "Textfield": "Campo de texto",
  "Range Slider": "Deslizador de Rango",
  "Menu": "Menú",
  "Snackbar": "Snackbar",
  "Tabs": "Pestañas",
  "Form Elements": "Elementos de Formulario",
  "Form Layouts": "Diseños de Formulario",
  "Authentication": "Autenticación",
  "Page Not Found - 404": "Página No Encontrada - 404",
  "Not Authorized - 401": "No Autorizado - 401",
  "Server Error - 500": "Error del Servidor - 500",
  "2": "2",
  "Forms": "Formularios",
  "Timeline": "Línea de tiempo",
  "Disabled Menu": "Menú Deshabilitado",
  "Help Center": "Centro de Ayuda",
  "Verify Email": "Verificar Correo Electrónico",
  "Verify Email v1": "Verificar Correo v1",
  "Verify Email v2": "Verificar Correo v2",
  "Two Steps": "Dos Pasos",
  "Two Steps v1": "Dos Pasos v1",
  "Two Steps v2": "Dos Pasos v2",
  "Custom Input": "Entrada Personalizada",
  "Extensions": "Extensiones",
  "Tour": "Jornada",
  "Register Multi-Steps": "Registro en Varios Pasos",
  "Wizard Examples": "Ejemplos de Asistente",
  "Checkout": "Pagar",
  "Create Deal": "Crear Oferta",
  "Property Listing": "Listado de Propiedades",
  "Roles & Permissions": "Roles y Permisos",
  "Roles": "Roles",
  "Simple Table": "Tabla Simple",
  "Tables": "Tablas",
  "Data Table": "Tabla de Datos",
  "Permissions": "Permisos",
  "Apps": "Aplicaciones",
  "Misc": "Varios",
  "Wizard Pages": "Páginas del Asistente",
  "Form Wizard": "Asistente de Formulario",
  "Numbered": "Numerado",
  "3": "3",
  "ecommerce": "comercio electrónico",
  "Ecommerce": "Comercio Electrónico",
  "Editors": "Editores",
  "Front Pages": "Páginas Principales",
  "Landing": "Aterrizaje",
  "checkout": "pagar",
  "Payment": "Pago",
  "Swiper": "Swiper",
  "Product": "Producto",
  "Category": "Categoría",
  "Order": "Pedido",
  "Details": "Detalles",
  "Customer": "Cliente",
  "Manage Review": "Gestionar Reseña",
  "Referrals": "Referencias",
  "Settings": "Configuración",
  "Overview": "Visión general",
  "My Course": "Mi Curso",
  "Course Details": "Detalles del Curso",
  "Academy": "Academia",
  "Logistics": "Logística",
  "Dashboard": "Panel",
  "Fleet": "Flota",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "maintenance": "Mantenimiento",
  "maintenance-page": {
    "title": "Configuración de mantenimiento",
    "notification_section": "Notificación global",
    "notification_placeholder": "Ingrese el mensaje de notificación para todos los usuarios",
    "notification_hint": "Este mensaje se mostrará a todos los usuarios autenticados como advertencia",
    "games_section": "Bloqueo de sesiones",
    "games_blocked_label": "Bloquear nuevas sesiones",
    "games_blocked_hint": "Cuando está activado, los usuarios no pueden crear ni iniciar nuevas sesiones. Las sesiones existentes aún se pueden unir.",
    "save": "Guardar",
    "clear": "Borrar",
    "clear_confirm": "¿Está seguro de que desea borrar la notificación?",
    "last_updated": "Última actualización",
    "updated_by": "por",
    "games_blocked_message": "Pedimos disculpas por las molestias. La plataforma se encuentra actualmente en mantenimiento. Las sesiones no están disponibles temporalmente."
  },
  "$vuetify": {
    "badge": "Insignia",
    "noDataText": "No hay datos disponibles",
    "close": "Cerrar",
    "open": "abrir",
    "carousel": {
      "ariaLabel": {
        "delimiter": "delimitador"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Elementos por página:",
      "itemsPerPageAll": "Todos",
      "pageText": "{0}-{1} de {2}",
      "firstPage": "Primera Página",
      "prevPage": "Página Anterior",
      "nextPage": "Página Siguiente",
      "lastPage": "Última Página"
    },
    "pagination": {
      "ariaLabel": {
        "root": "raíz",
        "previous": "anterior",
        "next": "siguiente",
        "first": "primero",
        "last": "último",
        "currentPage": "página actual",
        "page": "página"
      }
    },
    "input": {
      "clear": "limpiar",
      "appendAction": "acción de añadir",
      "prependAction": "acción de anteponer",
      "counterSize": "tamaño del contador",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "tamaño del contador"
    },
    "rating": {
      "ariaLabel": {
        "item": "elemento"
      }
    }
  },
  "skill_reports": {
    "skill_development_report": "Informe de Desarrollo de Habilidades",
    "generate": "Generar",
    "generate_description": "Generar un informe completo de desarrollo de habilidades para un período seleccionado",
    "manager_description": "Generar informes de desarrollo de habilidades para los empleados de su organización",
    "date": "Fecha",
    "competence": "Competencia",
    "period": "Período",
    "status_label": "Estado",
    "actions": "Acciones",
    "employee": "Empleado",
    "view": "Ver informe",
    "download_pdf": "Descargar PDF",
    "no_reports": "Aún no se han generado informes",
    "data_not_available": "Los datos del informe aún no están disponibles",
    "generation_failed": "Error al generar el informe",
    "retry": "Reintentar",
    "rate_limit_exceeded": "Se alcanzó el límite de generación de informes. Por favor, inténtelo más tarde.",
    "too_many_pending": "Tiene demasiados informes en progreso. Por favor, espere a que se completen.",
    "no_games_for_report": "No se encontraron sesiones completadas para el período y la competencia seleccionados. No es posible generar el informe.",
    "report_already_exists": "Ya existe un informe con estos parámetros. Consulte la lista a continuación.",
    "period_too_long": "El período del informe no debe superar un año.",
    "invalid_parameters": "Compruebe la competencia y el periodo",
    "filter_by_employee": "Filtrar por empleado...",
    "batch": {
      "mode_single": "Informe único",
      "mode_batch": "Lote",
      "load_employees": "Mostrar empleados",
      "sessions": "Sesiones",
      "no_candidates": "No hay empleados con sesiones completadas para la competencia y el periodo seleccionados",
      "generate_selected": "Generar ({count})",
      "selected_limit": "Se pueden seleccionar como máximo {max} empleados a la vez",
      "progress": "{ready} de {total} listos",
      "failed_count": "Errores: {count}",
      "status_unknown": "Estado desconocido",
      "status_unknown_hint": "El informe no se encontró en la lista: consulte la tabla de informes de abajo",
      "reused": "Informes reutilizados: {count} — generados en las últimas {hours} h y no vueltos a crear",
      "reused_badge": "Reutilizado",
      "reused_on": "Generado el {date}",
      "download_all": "Descargar todo",
      "toggle_details": "Mostrar el contenido del lote",
      "dismiss_confirm": "Este lote todavía se está generando. ¿Quitarlo de la pantalla? Se perderán el progreso y el botón «Descargar todo»; los informes permanecen en la lista de abajo.",
      "archive_unavailable": "No se pudo crear el archivo: algunos informes aún no están listos o ya no están disponibles",
      "archive_failed": "No se pudo descargar el archivo",
      "archive_building": "Creando el archivo…",
      "archive_build_failed": "No se pudo crear el archivo. Inténtelo de nuevo.",
      "candidates_failed": "No se pudo cargar la lista de empleados",
      "stale_selection": "Algunos de los empleados seleccionados ya no están disponibles. La lista se ha actualizado: vuelva a seleccionar."
    },
    "quota": {
      "remaining_hour": "Límite de informes: {limit} por hora. Puede solicitar {remaining} más ahora mismo. Seleccione menos empleados o vuelva a intentarlo a las {time}.",
      "remaining_day": "Límite de informes: {limit} por día. Puede solicitar {remaining} más ahora mismo. Seleccione menos empleados o vuelva a intentarlo a las {time}.",
      "exhausted_hour": "Se alcanzó el límite de informes ({limit} por hora). Se restablecerá a las {time}.",
      "exhausted_day": "Se alcanzó el límite de informes ({limit} por día). Se restablecerá a las {time}.",
      "too_large_hour": "Límite de informes: {limit} por hora. Seleccione menos empleados.",
      "too_large_day": "Límite de informes: {limit} por día. Seleccione menos empleados."
    },
    "status": {
      "pending": "Pendiente",
      "collecting_data": "Recopilando datos...",
      "analyzing": "Análisis IA...",
      "generating_pdf": "Generando PDF...",
      "ready": "Listo",
      "failed": "Fallido"
    },
    "report": {
      "kicker": "Informe de desarrollo de competencia",
      "position": "Cargo",
      "department": "Departamento",
      "period": "Período",
      "games_count": "Sesiones realizadas",
      "not_specified_f": "No especificada",
      "not_specified_n": "No especificado",
      "fig": {
        "your_average": "Tu puntuación media",
        "company_average": "Promedio de la empresa",
        "participants": "Participantes en el período",
        "skills_count": "Habilidades evaluadas"
      },
      "sec": {
        "profile": "Perfil de la Competencia",
        "trend": "Evolución por Sesión",
        "strengths": "En Qué Apoyarte",
        "priorities": "Tres Prioridades de Desarrollo",
        "skills": "Análisis por Habilidad",
        "plan": "Plan a Tres Meses"
      },
      "legend": {
        "you": "Tu puntuación",
        "company": "Promedio de la empresa"
      },
      "dotplot_caption": "Desviación respecto al promedio — de la mayor ventaja al mayor rezago",
      "trend_disclaimer": "Las puntuaciones de las sesiones no son directamente comparables: la dificultad de los casos varía de una sesión a otra. Una bajada no significa por sí sola que la habilidad haya retrocedido: el gráfico es una observación, no un veredicto.",
      "no_comparison": "La comparación con el promedio de la empresa no está disponible: durante el período, menos de tres personas realizaron sesiones de esta competencia. El informe se basa en puntuaciones absolutas.",
      "skill": {
        "works": "Qué funciona",
        "blocks": "Qué lo dificulta",
        "actions": "Qué hacer",
        "out_of_ten": "de 10",
        "company_short": "empresa"
      },
      "level": {
        "outstanding": "Resultado destacado",
        "strength": "Punto fuerte",
        "meets_standard": "Al nivel de la empresa",
        "needs_attention": "Requiere atención",
        "needs_development": "Área de desarrollo"
      },
      "plan": {
        "month": "Mes",
        "goals": "Objetivos",
        "actions": "Acciones"
      },
      "colophon": {
        "built_on": "El informe se basa en las sesiones del período {from} — {to}. Total de sesiones: {count}.",
        "comparison": "La comparación es con el promedio de la empresa del mismo período. Participantes: {count}."
      }
    }
  },
  "api-tokens": "Tokens de API",
  "api-tokens-page": {
      "select_user": "Usuario",
      "select_user_hint": "Seleccione un usuario para ver y gestionar sus tokens de API.",
      "no_users_found": "No se encontraron usuarios",
      "no_tokens": "Este usuario no tiene tokens de API.",
      "token_name": "Nombre",
      "abilities": "Permisos",
      "ability": "Permiso",
      "created_at": "Creado el",
      "last_used_at": "Último uso el",
      "expires_at": "Expira el",
      "actions": " ",
      "issue_token": "Emitir token",
      "issue": "Emitir",
      "issue_failed": "Error al emitir el token",
      "token": "Token",
      "plaintext_warning": "Copie este token ahora — no se volverá a mostrar.",
      "revoke": "Revocar",
      "revoke_confirm": "¿Está seguro de que desea revocar este token? Las integraciones que lo usen dejarán de funcionar."
  },
  "subscription": {
    "current_plan": "Plan Actual",
    "expires_at": "Expira: {date}",
    "no_active_plan": "Sin plan de suscripción activo",
    "quota_warning": "Cuota restante baja",
    "regular_games": "Sesiones Regulares",
    "ai_games": "Sesiones IA",
    "any_games": "Cualquier sesión",
    "used_of": "{used} de {limit}",
    "remaining": "{count} restantes",
    "quota_exceeded": "Cuota de función superada",
    "tickets_only": "Paquetes de Créditos",
    "session_package": "Paquete de sesiones",
    "games_available": "Sesiones",
    "users": "Usuarios",
    "active_users": "Usuarios activos",
    "active_tickets": "Paquetes de Créditos",
    "ticket_charges": "{charges} créditos",
    "ticket_no_expiry": "Sin vencimiento",
    "unlimited": "Ilimitado",
    "no_game_limits": "Sin restricciones en el número de sesiones"
  },
  "knowledge-base-page": {
    "provider-unsupported": "La base de conocimientos no está disponible con el proveedor de IA actual de tu organización."
  },
  "candidate-page": {
    "document_title": "Entrevista",
    "greeting": "¡Hola, {name}!",
    "intro_lead": "{organization} le invita a una entrevista con un interlocutor virtual para la vacante «{vacancy}».",
    "duration": "La entrevista dura aproximadamente {minutes} min.",
    "requirements_title": "Qué necesitará",
    "requirement_mic": "Micrófono en buen estado; idealmente, auriculares con micrófono",
    "requirement_camera_required": "Cámara encendida: es obligatoria para esta entrevista",
    "requirement_camera_optional": "La cámara es opcional, pero con ella la conversación resulta más natural",
    "requirement_browser": "Un equipo con una versión reciente de Chrome, Edge o Safari",
    "requirement_network": "Una conexión estable a internet y un lugar tranquilo donde nadie le interrumpa",
    "continue": "Continuar",
    "consent": {
      "accept": "He leído el texto y doy mi consentimiento para el tratamiento de mis datos personales",
      "back": "Atrás",
      "start": "Comenzar la entrevista"
    },
    "terminal": {
      "finished": {
        "title": "¡Gracias!",
        "text": "La entrevista ha terminado y el resultado se ha enviado al reclutador, quien se pondrá en contacto con usted. Puede cerrar esta página."
      },
      "already_completed": {
        "title": "Entrevista ya completada",
        "text": "Este enlace ya se ha utilizado para una entrevista completada. Póngase en contacto con el reclutador si necesita repetirla."
      },
      "not_found": {
        "title": "Enlace no encontrado",
        "text": "Puede que la dirección tenga un error o que el enlace ya no sea válido. Revise el correo del reclutador o póngase en contacto con él."
      },
      "session_conflict": {
        "title": "Ha iniciado sesión con otra cuenta",
        "text": "Cierre la sesión de la cuenta actual o abra el enlace en una ventana privada del navegador."
      },
      "link_revoked": {
        "title": "El acceso a este enlace está cerrado",
        "text": "El reclutador ha revocado este enlace. Póngase en contacto con él para obtener uno nuevo."
      },
      "link_expired": {
        "title": "El enlace ha caducado",
        "text": "Póngase en contacto con el reclutador para que le emita un nuevo enlace."
      },
      "attempts_exhausted": {
        "title": "No quedan intentos",
        "text": "Se han utilizado todos los intentos disponibles para este enlace. Póngase en contacto con el reclutador."
      },
      "unavailable": {
        "title": "No se puede iniciar en este momento",
        "text": "Inténtelo de nuevo más tarde o póngase en contacto con el reclutador."
      },
      "rate_limited": {
        "title": "Demasiados intentos",
        "text": "Espere un minuto y vuelva a cargar la página."
      },
      "aborted": {
        "title": "La entrevista no se inició",
        "text": "Vuelva a cargar la página e inténtelo de nuevo. Si no funciona, póngase en contacto con el reclutador."
      },
      "generic": {
        "title": "Algo salió mal",
        "text": "Vuelva a cargar la página e inténtelo de nuevo. Si no funciona, póngase en contacto con el reclutador."
      }
    }
  },
  "recruiting-page": {
    "title": "Reclutamiento",
    "create": "Nueva vacante",
    "edit": "Editar vacante",
    "empty": "Aún no hay vacantes",
    "load_error": "No se pudo cargar la lista de vacantes",
    "retry": "Reintentar",
    "back": "Volver a las vacantes",
    "open": "Candidatos",
    "archive": "Archivar",
    "no_expiry": "Sin vencimiento",
    "confirm_archive": "¿Archivar esta vacante? Ya no podrá emitir enlaces para ella.",
    "headers": {
      "title": "Vacante",
      "scenario": "Escenario",
      "status": "Estado",
      "expires_at": "Válida hasta",
      "actions": "Acciones"
    },
    "status": {
      "draft": "Borrador",
      "active": "Activa",
      "archived": "Archivada"
    },
    "dialog": {
      "title_label": "Título de la vacante",
      "scenario_label": "Escenario de la entrevista",
      "scenario_placeholder": "Seleccione un escenario para la entrevista con IA",
      "scenario_hint": "Solo se muestran los escenarios aptos para una sesión contra IA",
      "status_label": "Estado",
      "expires_label": "Válida hasta",
      "expires_hint": "Déjelo vacío para que la vacante no tenga vencimiento",
      "save": "Guardar",
      "cancel": "Cancelar"
    },
    "messages": {
      "created": "Vacante creada",
      "updated": "Vacante actualizada",
      "archived": "Vacante archivada",
      "revoked": "Enlace revocado",
      "attempt_granted": "Se ha concedido un intento más al candidato",
      "copied": "Enlace copiado",
      "error": "Algo salió mal"
    },
    "candidates": {
      "title": "Candidatos",
      "empty": "Aún no se ha emitido ningún enlace para esta vacante",
      "load_error": "No se pudo cargar la lista de candidatos",
      "issue": "Emitir enlace",
      "import": "Importar desde un archivo",
      "expired": "Caducado",
      "no_games": "Entrevista no iniciada",
      "attempts": "{used} de {allowed}",
      "revoke": "Revocar enlace",
      "extra_attempt": "Conceder un intento más",
      "open_result": "Abrir el resultado de la entrevista",
      "confirm_revoke": "¿Revocar el enlace de este candidato? El acceso se pierde de inmediato, incluida una entrevista en curso.",
      "confirm_extra_attempt": "¿Conceder a este candidato un intento más?",
      "headers": {
        "candidate": "Candidato",
        "link_status": "Enlace",
        "invite": "Invitación",
        "game_status": "Entrevista",
        "attempts": "Intentos",
        "expires_at": "Enlace válido hasta",
        "actions": "Acciones"
      },
      "link_status": {
        "created": "Emitido",
        "opened": "Abierto",
        "in_progress": "Entrevista en curso",
        "completed": "Entrevista completada",
        "revoked": "Revocado"
      },
      "invite_status": {
        "not_sent": "No enviada",
        "queued": "En cola",
        "sent": "Enviada",
        "failed": "No se pudo enviar"
      },
      "invite_sent_at": "El servicio de correo aceptó el mensaje el {date}",
      "invite_failure": {
        "rejected": "El servicio de correo rechazó el mensaje — envíe usted mismo el enlace al candidato",
        "transport": "Error de envío — envíe usted mismo el enlace al candidato",
        "revoked": "El enlace fue revocado",
        "sending_disabled": "El envío de correos está desactivado",
        "blocked": "La dirección está en la lista de bloqueo — envíe usted mismo el enlace al candidato"
      }
    },
    "issue_dialog": {
      "title": "Emitir enlace personal",
      "name": "Nombre",
      "last_name": "Apellidos",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "attempts": "Intentos permitidos",
      "expires_at": "Enlace válido hasta",
      "expires_hint": "Déjelo vacío para heredar el vencimiento de la vacante",
      "submit": "Emitir enlace",
      "close": "Cerrar",
      "result_title": "Enlace emitido",
      "warning": "Copie el enlace ahora — se muestra exactamente una vez. En la base de datos solo se guarda su hash, así que el enlace no se puede recuperar: si se pierde, habrá que revocarlo y emitir uno nuevo.",
      "copy": "Copiar",
      "copied": "Copiado",
      "send_invite": "Enviar una invitación a {email}",
      "send_invite_no_email": "Enviar una invitación por correo electrónico",
      "send_invite_blocked": "Esta dirección está en la lista de bloqueo — el correo no se enviará",
      "invite_queued": "Invitación en cola para {email}",
      "invite_blocked": "Invitación no enviada: {email} está en la lista de bloqueo. Envíe usted mismo el enlace al candidato"
    },
    "import_dialog": {
      "title": "Importar candidatos",
      "subtitle": "Cada fila del archivo se convierte en un candidato y un enlace personal.",
      "file": "Archivo con la lista de candidatos",
      "columns": "Columnas: Nombre, Apellidos, Email, Teléfono",
      "limits": "xlsx o CSV con «;», hasta 200 filas y 10 MB",
      "size_error": "El archivo supera los 10 MB",
      "download_example": "Descargar ejemplo",
      "note_title": "Los enlaces solo son visibles en el archivo descargado",
      "note_text": "El archivo se descarga en cuanto finaliza la importación. En la base de datos solo se guardan los hashes de los enlaces, así que no es posible exportarlos una segunda vez: guarde el archivo.",
      "submit": "Importar",
      "cancel": "Cancelar",
      "result_title": "Enlaces emitidos",
      "result": "Enlaces emitidos: {count}. El archivo se ha descargado.",
      "invites_blocked": "Invitaciones no enviadas: {count}. Estas direcciones están en la lista de bloqueo — envíe usted mismo los enlaces a esos candidatos.",
      "saved_title": "Guarde el archivo descargado",
      "saved_text": "Es la única copia de estos enlaces: la base de datos solo guarda sus hashes. Un enlace perdido solo se puede revocar y volver a emitir.",
      "download_again": "Descargar el archivo de nuevo",
      "errors_title": "Filas rechazadas",
      "error_row": "Fila {row}: {error}",
      "errors_truncated": "…y {count} filas rechazadas más. Arriba se muestran las primeras 50.",
      "send_invites": "Enviar invitaciones por correo a los candidatos",
      "send_invites_hint": "Los candidatos sin dirección de correo no recibirán la invitación"
    }
  },
  "ai-reports": "Informes de IA",
  "ai-reports-page": {
    "title": "Informes de IA",
    "subtitle": "Describa el informe con sus propias palabras: elaboramos la especificación, mostramos una vista previa y lo exportamos a Excel.",
    "status": {
      "draft": "Borrador",
      "pending": "Generándose",
      "ready": "Listo",
      "failed": "No se generó"
    },
    "list": {
      "title": "Mis informes",
      "new": "Nuevo informe",
      "empty": "Aún no hay informes. Haga clic en «Nuevo informe» y describa lo que necesita.",
      "untitled": "Sin título",
      "delete": "Eliminar informe",
      "delete_confirm": "¿Eliminar el informe junto con el archivo generado?",
      "deleted": "Informe eliminado"
    },
    "dialog": {
      "title": "Diálogo",
      "open_dictionary": "Diccionario de datos",
      "placeholder": "Por ejemplo: cuántas partidas realizó cada departamento el último trimestre",
      "send": "Enviar",
      "empty_title": "¿Qué debe mostrar el informe?",
      "empty_text": "Escríbalo con palabras sencillas: qué datos, para qué período y en qué desglose. Si falta algo, se lo preguntaré.",
      "examples_title": "Por ejemplo:",
      "examples": {
        "e1": "Cuántas partidas realizó cada departamento el último trimestre",
        "e2": "Puntuación media de competencias en el departamento de ventas en 2026",
        "e3": "Empleados que no han jugado en más de un mes",
        "e4": "Candidatos por vacante y el estado de sus enlaces en los últimos 30 días"
      },
      "thinking": "Generando el informe…",
      "waiting_hint": "La respuesta aparecerá aquí sola: no hace falta actualizar la página.",
      "retry": "Reintentar",
      "dismiss": "Descartar",
      "spec_ready": "El informe está listo: revise la vista previa a continuación y genere el archivo.",
      "stuck_title": "Parece que estamos dando vueltas en círculo",
      "stuck_text": "Consulte el diccionario de datos y reformule la solicitud con esos términos: es más rápido que responder otra pregunta aclaratoria.",
      "rejected_title": "Este informe aún no se puede generar",
      "reason": {
        "no_such_measure": "No existe esa medida en nuestros datos. Consulte la lista de medidas en el diccionario.",
        "no_such_field": "No existe ese campo en nuestros datos. Consulte la lista de campos en el diccionario.",
        "cross_dataset": "La solicitud necesita datos de dos conjuntos de datos a la vez. Divídala en dos informes.",
        "window_function": "Aún no se admiten las proporciones del total, las posiciones en un ranking ni la comparación con el período anterior.",
        "other": "La solicitud excede los datos disponibles. Consulte el diccionario e intente con otra formulación."
      },
      "usage": {
        "employees": "sin empleados | {n} empleado | {n} empleados",
        "games": "sin partidas | {n} partida | {n} partidas",
        "scenarios": "sin escenarios | {n} escenario | {n} escenarios",
        "evaluations": "sin evaluaciones | {n} evaluación | {n} evaluaciones",
        "candidates": "sin candidatos | {n} candidato | {n} candidatos"
      },
      "option_created_at": "alta: {date}"
    },
    "preview": {
      "title": "Vista previa",
      "no_report": "Elija un informe a la izquierda o inicie uno nuevo.",
      "no_spec": "Describa el informe en el diálogo: la vista previa aparecerá en cuanto se entienda la solicitud.",
      "spec_title": "Qué contendrá el informe",
      "rows_hint": "Se muestran las primeras {count} filas",
      "total": "Total de filas: {count}",
      "zero_rows": "Esta solicitud no devuelve ninguna fila. Amplíe el período o quite filtros: no tiene sentido generar un archivo vacío.",
      "zero_rows_hint": "Revise los valores de los filtros: puede que no haya datos para ellos",
      "duplicate_rows": "Algunas filas de la vista previa son idénticas: las columnas elegidas no distinguen los registros de este conjunto de datos. Compruebe qué significa realmente una fila aquí: puede faltar una columna que las diferencie.",
      "too_many_rows": "El informe tiene {count} filas, el máximo es {max}. Acote el período o añada filtros: al superar el límite, el archivo no se genera en absoluto, no se trunca.",
      "generate": "Generar archivo",
      "regenerate": "Generar de nuevo",
      "queued": "El archivo se está generando; la tarjeta se actualizará sola cuando esté listo.",
      "failed": "No se pudo generar el informe",
      "download": "Descargar .xlsx",
      "downloads": "Descargas: {count}",
      "ttl_warning": "El archivo se conserva durante {days} días y luego se elimina: descárguelo cuanto antes.",
      "expires_at": "Disponible hasta {date}",
      "expired": "El archivo se eliminó al vencer su período de conservación: genere el informe de nuevo."
    },
    "spec": {
      "dataset": "Datos",
      "columns": "Columnas",
      "measures": "Medidas",
      "group_by": "Desglose",
      "period": "Período",
      "period_value": "{field}: del {from} al {to}",
      "period_all": "Todo el período disponible",
      "filters": "Filtros",
      "having": "Condiciones sobre las medidas",
      "sort": "Orden",
      "limit": "Límite de filas",
      "limit_value": "primeras {count} filas",
      "granularity": {
        "year": "por año",
        "quarter": "por trimestre",
        "month": "por mes",
        "week": "por semana",
        "day": "por día",
        "dow": "por día de la semana"
      },
      "dir": {
        "asc": "ascendente",
        "desc": "descendente"
      },
      "filter": {
        "equals": "{field} — {value}",
        "not_equals": "{field} — no {value}",
        "in": "{field} — uno de: {value}",
        "not_in": "{field} — excepto: {value}",
        "gt": "{field} mayor que {value}",
        "gte": "{field} al menos {value}",
        "lt": "{field} menor que {value}",
        "lte": "{field} como máximo {value}",
        "contains": "{field} contiene «{value}»",
        "between": "{field} — del {from} al {to}",
        "is_null": "{field} no está cumplimentado",
        "is_not_null": "{field} está cumplimentado"
      }
    },
    "value": {
      "yes": "Sí",
      "no": "No"
    },
    "dictionary": {
      "title": "Diccionario de datos",
      "subtitle": "Todo lo que se puede incluir en un informe. La lista está actualizada en vivo: es la misma con la que se genera la especificación.",
      "fields": "Campos",
      "measures": "Medidas",
      "values": "Valores",
      "show_values": "Mostrar los valores de su organización",
      "hide_values": "Ocultar valores",
      "values_error": "No se pudieron cargar los valores: inténtelo de nuevo.",
      "values_empty": "Su organización aún no tiene valores para este campo.",
      "limits": {
        "title": "Lo que un informe no puede hacer",
        "pivot": "No se puede generar una tabla dinámica con una columna por participante o por pregunta. Pida la forma larga en su lugar: una fila por cada par participante-pregunta.",
        "window": "El informe no calcula la variación mes a mes, la proporción sobre el total, la posición en el ranking ni «los tres mejores de cada departamento». Tome el desglose por meses y termine el cálculo en Excel.",
        "missing": "Lo que el sistema no almacena no aparecerá en el informe: salarios, NPS y demás datos de otros sistemas no aparecerán bajo ningún nombre."
      },
      "empty": "El diccionario está vacío: contacte con su administrador.",
      "close": "Cerrar"
    },
    "errors": {
      "generic": "Algo salió mal. Inténtelo de nuevo.",
      "detail": "No se ha entendido: {value}",
      "rate_limit": "Demasiadas solicitudes. Espere un minuto e inténtelo de nuevo.",
      "download": "No se pudo descargar el archivo.",
      "turn_failed": "No se pudo obtener la respuesta. Envíe la consulta de nuevo.",
      "turn_stuck_in_queue": "La consulta no llegó a procesarse: esperó demasiado tiempo en la cola. Envíela de nuevo.",
      "unknown_resolution": "Esta opción ha quedado obsoleta: el informe ha cambiado mientras tanto. Ábralo de nuevo y precise su consulta."
    }
  },
    "externalLaunch": {
        "document_title": "Sesión de práctica",
        "intro": {
            "title": "Conversación de práctica",
            "lead": "Va a hablar con un interlocutor virtual. La conversación se graba y se evalúa, y el resultado volverá a su sistema de aprendizaje.",
            "requirements_title": "Qué necesitará",
            "requirement_mic": "Un micrófono en buen estado; idealmente, unos auriculares con micrófono",
            "requirement_camera": "La cámara es opcional, pero con ella la conversación resulta más natural",
            "requirement_browser": "Un equipo con una versión reciente de Chrome, Edge o Safari",
            "requirement_network": "Una conexión estable y un lugar tranquilo donde nadie le interrumpa",
            "start": "Empezar"
        },
        "relaunch_hint": "Vuelva a su sistema de aprendizaje y abra de nuevo el contenido.",
        "saving": "Guardando el resultado…",
        "review": {
            "document_title": "Resumen de la sesión",
            "attempt": "Intento {number}",
            "result": {
                "passed": "Aprobado",
                "failed": "No aprobado",
                "pending": "Aún sin evaluar"
            },
            "score_of_100": "{score} de 100",
            "threshold": "Umbral de aprobado: {threshold}",
            "skills_title": "Competencias y recomendaciones",
            "skills_empty": "Todavía no hay valoración por competencias para este intento.",
            "comments_title": "Comentarios sobre la grabación",
            "comments_empty": "No hay comentarios sobre esta grabación.",
            "loading": "Cargando el resumen",
            "error": {
                "not_found": {
                    "title": "El enlace no funciona",
                    "text": "El resumen ya no está disponible: el enlace ha caducado o el intento fue revocado."
                },
                "expired": {
                    "title": "La página ha caducado",
                    "text": "Vuelva a abrir el resumen desde el enlace de su sistema de aprendizaje."
                },
                "generic": {
                    "title": "No se puede mostrar el resumen",
                    "text": "Algo salió mal por nuestra parte. Intente abrir el enlace de nuevo."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "¡Gracias!",
                "text": "La conversación ha terminado. El resultado aparecerá en su sistema de aprendizaje cuando la evaluación esté lista. Puede cerrar esta página."
            },
            "aborted": {
                "title": "La conversación no se inició",
                "text": "Algo salió mal antes de que empezara la conversación."
            },
            "token_expired": {
                "title": "La sesión ha caducado",
                "text": "El acceso a esta conversación ya no es válido."
            },
            "not_found": {
                "title": "El enlace no funciona",
                "text": "Puede que la dirección tenga un error, o que el enlace ya no sea válido."
            },
            "rate_limited": {
                "title": "Demasiados intentos",
                "text": "Espere un minuto antes de volver a intentarlo."
            },
            "generic": {
                "title": "No se puede iniciar en este momento",
                "text": "Algo salió mal por nuestra parte."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "El contenido está cerrado",
                "text": "Este contenido ya no está disponible para practicar."
            },
            "publication_draft": {
                "title": "El contenido aún no está publicado",
                "text": "La práctica de este contenido todavía no se ha abierto."
            },
            "publication_expired": {
                "title": "El contenido ha caducado",
                "text": "El periodo en el que se podía practicar con este contenido ha terminado."
            },
            "feature_disabled": {
                "title": "El contenido está cerrado",
                "text": "La práctica desde el sistema de aprendizaje está desactivada para su organización."
            },
            "connection_disabled": {
                "title": "El contenido está cerrado",
                "text": "La conexión con su sistema de aprendizaje está desactivada. Contacte con la persona que le asignó el curso."
            },
            "launch_limit_reached": {
                "title": "Se ha alcanzado el límite",
                "text": "Este contenido ya se ha usado para el número máximo de conversaciones."
            },
            "daily_budget_exhausted": {
                "title": "Suficiente por hoy",
                "text": "Ha alcanzado el número de conversaciones permitidas al día. Vuelva a intentarlo mañana."
            },
            "attempts_exhausted": {
                "title": "No quedan intentos",
                "text": "Ha usado todos los intentos permitidos para este contenido."
            },
            "quota_exhausted": {
                "title": "No se puede iniciar en este momento",
                "text": "Su organización no tiene conversaciones disponibles. Contacte con la persona que le asignó el curso."
            },
            "user_limit_reached": {
                "title": "No se puede iniciar en este momento",
                "text": "Su organización no tiene plazas libres. Contacte con la persona que le asignó el curso."
            },
            "scenario_unavailable": {
                "title": "El contenido no está disponible",
                "text": "La conversación asociada a este contenido ya no existe."
            },
            "assignment_check_unavailable": {
                "title": "No se puede iniciar en este momento",
                "text": "No hemos podido confirmar que este contenido esté asignado a usted. Contacte con la persona que le asignó el curso."
            },
            "code_invalid": {
                "title": "El enlace ya no es válido",
                "text": "Este enlace ya se ha usado o su tiempo ha expirado."
            },
            "channel_verification_failed": {
                "title": "El sistema de aprendizaje no respondió",
                "text": "No hemos podido confirmar la solicitud con su sistema de aprendizaje."
            },
            "external_system_unavailable": {
                "title": "El sistema de aprendizaje no responde",
                "text": "No hemos podido confirmar en el sistema de aprendizaje que el curso esté asignado a usted. Vuelva a intentarlo dentro de unos minutos."
            },
            "user_not_found": {
                "title": "No hemos podido identificarle",
                "text": "No existe una cuenta para usted aquí, y su organización no las crea automáticamente. Contacte con la persona que le asignó el curso."
            },
            "user_unavailable": {
                "title": "Su cuenta está desactivada",
                "text": "Contacte con la persona que le asignó el curso."
            },
            "user_deleted": {
                "title": "Su cuenta ha sido eliminada",
                "text": "Contacte con la persona que le asignó el curso."
            },
            "email_taken_linking_disabled": {
                "title": "No hemos podido identificarle",
                "text": "Su dirección de correo ya pertenece a otra cuenta aquí. Contacte con la persona que le asignó el curso."
            },
            "service_role_not_allowed": {
                "title": "Con esta cuenta no se puede practicar",
                "text": "Las cuentas de administrador no participan en conversaciones de práctica. Use su propia cuenta de alumno."
            },
            "unverified_request": {
                "title": "No hemos podido confirmar la solicitud",
                "text": "Su sistema de aprendizaje no confirmó que esta conversación la iniciara usted."
            }
        },
        "manage": {
            "nav": {
                "group": "Lanzamiento externo",
                "publications": "Publicaciones",
                "connections": "Conexiones LMS"
            },
            "messages": {
                "error": "Algo salió mal. Inténtelo de nuevo.",
                "load_error": "No se pudieron cargar los datos."
            },
            "connections": {
                "title": "Conexiones LMS",
                "subtitle": "Cuentas de sistemas de aprendizaje desde las que esta organización lanza la práctica.",
                "create": "Añadir conexión",
                "edit": "Editar",
                "set_credentials": "Establecer credenciales",
                "empty": "Todavía no hay conexiones.",
                "secret_missing": "No establecido",
                "no_expiry": "No caduca",
                "headers": {
                    "account": "Cuenta",
                    "base_url": "Dirección",
                    "client_id": "ID de cliente",
                    "secret": "Secreto",
                    "status": "Estado",
                    "expires_at": "Caducidad de las credenciales",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Sin credenciales",
                    "active": "Activa",
                    "expired": "Credenciales caducadas",
                    "disabled": "Desactivada"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Nueva conexión",
                    "edit_title": "Conexión",
                    "immutable_hint": "El sistema de aprendizaje y la cuenta no se pueden cambiar: definen el espacio de identidad de los alumnos. Una cuenta distinta es una conexión nueva.",
                    "lms_label": "Sistema de aprendizaje",
                    "account_key_label": "Cuenta",
                    "account_key_hint": "El identificador de la cuenta en el sistema de aprendizaje.",
                    "base_url_label": "Dirección de la API REST de iSpring",
                    "base_url_hint": "Por ejemplo, https://api-learn.ispringlearn.ru. No es la dirección del portal de la empresa: aquí se envía el secreto.",
                    "base_url_https": "La dirección debe empezar por https://",
                    "enabled_label": "La conexión está activada",
                    "enabled_hint": "Una conexión nunca se elimina, se desactiva. Las publicaciones y los lanzamientos permanecen en las listas, pero se rechazan los nuevos lanzamientos y los resultados dejan de enviarse al sistema de aprendizaje.",
                    "credentials_optional": "Las credenciales son opcionales. Sin ellas, la conexión funciona en modo limitado.",
                    "client_id_label": "ID de cliente",
                    "secret_label": "Secreto",
                    "secret_hint": "Se almacena cifrado. No se puede volver a leer nunca; solo se muestran los cuatro últimos caracteres.",
                    "expires_at_label": "Caducidad de las credenciales",
                    "expires_at_hint": "Déjelo vacío si las credenciales no caducan."
                },
                "credentials_dialog": {
                    "title": "Credenciales",
                    "lead": "El nuevo secreto sustituye al anterior. La conexión conserva su identificador, y los enlaces de los alumnos y sus lanzamientos permanecen donde están.",
                    "secret_hint": "El secreto anterior ya no es necesario y no se puede volver a leer."
                },
                "messages": {
                    "saved": "Conexión guardada",
                    "credentials_saved": "Credenciales guardadas"
                }
            },
            "publications": {
                "title": "Publicaciones",
                "subtitle": "Escenarios abiertos para lanzar desde un sistema de aprendizaje.",
                "create": "Nueva publicación",
                "edit": "Editar",
                "enable": "Activar",
                "disable": "Desactivar",
                "open_journal": "Registro",
                "download_package": "Descargar paquete",
                "empty": "Todavía no hay publicaciones.",
                "no_connections": "Todavía no hay una conexión con un sistema de aprendizaje. La configura un administrador de la plataforma.",
                "no_expiry": "Sin caducidad",
                "attempts_unlimited": "Ilimitados",
                "immutable_hint": "La conexión, el escenario y el canal de entrega no se pueden cambiar: están integrados en el paquete ya cargado en el sistema de aprendizaje. Todo lo demás se aplica sin reconstruirlo.",
                "headers": {
                    "scenario": "Escenario",
                    "connection": "Conexión",
                    "channel": "Canal",
                    "status": "Estado",
                    "settings": "Configuración",
                    "expires_at": "Caduca",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Intentos: {value}",
                    "threshold": "Umbral de aprobado: {value}"
                },
                "status": {
                    "draft": "Borrador",
                    "active": "Activa",
                    "disabled": "Desactivada"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Solo el estado",
                    "status_and_score": "Estado y puntuación",
                    "status_score_and_review": "Estado, puntuación y un enlace al resumen"
                },
                "warnings": {
                    "limited_mode": "Modo limitado: la puntuación y el resultado no aparecerán en el sistema de aprendizaje, y no se realiza la verificación de asignación.",
                    "connection_disabled": "La conexión está desactivada: no se aceptan lanzamientos a través de esta publicación hasta que un administrador la vuelva a activar.",
                    "assignment_check_off": "Con esta opción desactivada, no se detecta una reasignación del curso.",
                    "no_course_binding": "La publicación no está vinculada a un curso: la puntuación no llegará al sistema de aprendizaje."
                },
                "dialog": {
                    "connection_label": "Conexión",
                    "scenario_label": "Escenario",
                    "channel_label": "Canal de entrega",
                    "channel_hint": "Se integra en el paquete y no se puede cambiar después.",
                    "status_label": "Estado",
                    "status_hint": "Una publicación nunca se elimina, se desactiva. Después de eso, se rechazan los nuevos lanzamientos y se cancelan los resultados que aún no se han enviado.",
                    "settings_section": "Configuración de los intentos",
                    "attempts_label": "Intentos por alumno",
                    "attempts_unlimited": "Sin límite",
                    "daily_budget_label": "Lanzamientos al día por alumno",
                    "daily_budget_hint": "Protege la cuota: cada conversación iniciada se descuenta y nunca se devuelve.",
                    "result_mode_label": "Qué se envía al sistema de aprendizaje",
                    "pass_threshold_label": "Umbral de aprobado, 0-100",
                    "result_wait_label": "Tiempo de espera de la evaluación, en horas",
                    "result_wait_hint": "Pasado ese tiempo, el lanzamiento notifica «sin resultado».",
                    "launch_limit_label": "Límite total de lanzamientos",
                    "launch_limit_hint": "Déjelo vacío para no fijar un límite.",
                    "assignment_check_label": "Verificar la asignación en el sistema de aprendizaje",
                    "binding_section": "Vinculación en el sistema de aprendizaje",
                    "external_course_label": "ID del curso",
                    "external_item_label": "ID del elemento",
                    "expires_label": "Caducidad de la publicación",
                    "expires_hint": "Déjelo vacío si la publicación no caduca."
                },
                "key_dialog": {
                    "title": "La publicación se ha creado",
                    "warning": "La clave se muestra una sola vez y solo aquí. No se podrá volver a leer en ningún sitio: cópiela ahora e insértela en la configuración del paquete. Si la pierde, tendrá que crear una nueva publicación.",
                    "key_label": "Clave de la publicación",
                    "copied": "Copiado",
                    "package_hint": "La clave ya está dentro del paquete, así que no hay que pegarla en ningún sitio. Descargue el paquete y cárguelo en el sistema de aprendizaje. Puede volver a descargarlo en cualquier momento desde la página de publicaciones."
                },
                "messages": {
                    "saved": "Publicación guardada",
                    "enabled": "Publicación activada",
                    "disabled": "Publicación desactivada",
                    "download_failed": "No se pudo descargar el paquete. Actualice la página e inténtelo de nuevo."
                }
            },
            "journal": {
                "title": "Registro de lanzamientos",
                "unknown_scenario": "Escenario no disponible",
                "back": "A las publicaciones",
                "revoke": "Revocar el intento",
                "revoke_confirm": "¿Revocar este intento? El alumno perderá el acceso a la conversación y se cancelarán los envíos que no se hayan completado.",
                "retry_delivery": "Reintentar",
                "empty_launches": "Todavía no hay lanzamientos.",
                "empty_events": "Todavía no hay eventos.",
                "no_deliveries": "Este intento no tiene envíos.",
                "not_held_quota_charged": "No se realizó, cuota descontada",
                "relaunches": "regresos: {value}",
                "last_launch": "último lanzamiento: {value}",
                "result_deadline": "Esperando la evaluación hasta {value}",
                "learner_contacts": "Dirección enviada por el sistema de aprendizaje: {email}. Lanzado desde: {ip}",
                "score_passed": "{value} — aprobado",
                "score_failed": "{value} — suspendido",
                "tabs": {
                    "launches": "Intentos",
                    "events": "Eventos"
                },
                "headers": {
                    "learner": "Alumno",
                    "user": "Cuenta",
                    "attempt": "Intento",
                    "status": "Estado",
                    "game": "Conversación",
                    "started_at": "Iniciado",
                    "actions": " ",
                    "event_type": "Evento",
                    "refusal": "Motivo",
                    "request_proof": "Prueba de la solicitud",
                    "ip": "Dirección",
                    "user_agent": "Cliente",
                    "happened_at": "Cuándo"
                },
                "launch_status": {
                    "created": "Enlace emitido",
                    "started": "En curso",
                    "not_held": "No se realizó",
                    "awaiting_result": "Esperando la evaluación",
                    "result_ready": "Resultado entregado",
                    "evaluation_failed": "Sin evaluación",
                    "result_timed_out": "Se agotó el tiempo de espera",
                    "assignment_changed": "Asignación modificada",
                    "revoked": "Revocado"
                },
                "delivery": {
                    "version": "Versión",
                    "status": "Estado",
                    "outcome": "Resolución",
                    "result": "Resultado",
                    "score": "Puntuación",
                    "attempts": "Intentos",
                    "last_attempt": "Último intento",
                    "external_state": "Estado en el sistema de aprendizaje"
                },
                "delivery_status": {
                    "pending": "En cola",
                    "in_progress": "Enviando",
                    "done": "Completado",
                    "needs_attention": "Requiere atención"
                },
                "delivery_outcome": {
                    "accepted": "Aceptado",
                    "confirmed": "Confirmado",
                    "rejected_by_external": "Rechazado",
                    "retry": "Reintento programado",
                    "cancelled": "Cancelado",
                    "assignment_changed": "Asignación modificada"
                },
                "result": {
                    "passed": "Aprobado",
                    "failed": "Suspendido",
                    "not_held": "No se realizó",
                    "no_result": "Sin resultado"
                },
                "refusal": {
                    "publication_disabled": "Publicación desactivada",
                    "publication_draft": "Publicación en borrador",
                    "publication_expired": "Publicación caducada",
                    "feature_disabled": "Lanzamiento externo desactivado",
                    "connection_disabled": "Conexión desactivada",
                    "launch_limit_reached": "Límite de lanzamientos alcanzado",
                    "daily_budget_exhausted": "Presupuesto diario agotado",
                    "attempts_exhausted": "Intentos agotados",
                    "quota_exhausted": "Cuota de la organización agotada",
                    "user_limit_reached": "No quedan plazas libres",
                    "scenario_unavailable": "Escenario no disponible",
                    "assignment_check_unavailable": "Verificación de asignación no disponible",
                    "code_invalid": "Enlace ya usado o caducado",
                    "channel_verification_failed": "El sistema de aprendizaje no confirmó la solicitud",
                    "external_system_unavailable": "El sistema de aprendizaje no respondió a la verificación de asignación",
                    "user_not_found": "No hay cuenta para este alumno",
                    "user_unavailable": "Cuenta del alumno desactivada",
                    "user_deleted": "Cuenta del alumno eliminada",
                    "email_taken_linking_disabled": "El correo pertenece a otra cuenta",
                    "service_role_not_allowed": "Una cuenta de servicio no puede practicar",
                    "unverified_request": "Solicitud no confirmada"
                },
                "event_type": {
                    "launch_refused": "Lanzamiento rechazado",
                    "exchange_refused": "Enlace rechazado",
                    "exchange_succeeded": "Enlace utilizado"
                },
                "request_proof": {
                    "unverified": "No confirmada",
                    "assignment_verified": "Asignación confirmada"
                },
                "messages": {
                    "retry_queued": "Reintento en cola",
                    "revoked": "Intento revocado"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Entrenamiento",
            "interview": "Entrevista"
        },
        "load": {
            "loading": "Cargando la sesión…",
            "failed": "No se pudo cargar la sesión. Compruebe su conexión e inténtelo de nuevo.",
            "scenarioFailed": "No se pudo cargar el escenario",
            "scenarioRetry": "Reintentar"
        },
        "leave": {
            "confirm": "La conversación sigue en curso. Si sale de la página, no terminará y el tiempo seguirá corriendo. ¿Salir?",
            "confirmEnd": "La conversación sigue en curso. Si sale, terminará y se evaluará por lo que haya alcanzado a cubrir. ¿Salir?"
        },
        "elsewhere": {
            "interviewTitle": "La entrevista está abierta en otra pestaña",
            "interviewText": "La entrevista sigue en otra pestaña o en otro dispositivo. Continúela allí — puede cerrar esta pestaña.",
            "conversationTitle": "La conversación está abierta en otra pestaña",
            "conversationText": "La conversación sigue en otra pestaña o en otro dispositivo. Continúela allí — puede cerrar esta pestaña."
        },
        "prep": {
            "header": {
                "backToSessions": "A las sesiones",
                "themeToggleAriaLabel": "Cambiar tema"
            },
            "scenario": {
                "sectionLabel": "Escenario",
                "competenceLabel": "Competencia evaluada",
                "gameNumber": "Sesión #{number}",
                "duration": "{minutes} min",
                "readFull": "Leer completo",
                "generalLabel": "Información general",
                "playerLabel": "Información para usted"
            },
            "selfCamera": {
                "previewLabel": "Vista previa de su cámara",
                "off": "Cámara apagada"
            },
            "notes": {
                "empty": "Vacío"
            },
            "start": {
                "button": "Iniciar sesión",
                "interviewButton": "Iniciar entrevista",
                "resumeButton": "Volver a la conversación",
                "resumeHint": "La conversación ya está en curso — el tiempo sigue corriendo."
            }
        },
        "equipment": {
            "status": {
                "checking": "Comprobando el equipo",
                "waiting": "Esperando permiso",
                "denied": "Acceso denegado",
                "busy": "Dispositivo ocupado",
                "noCamera": "Sin cámara",
                "missing": "Sin micrófono",
                "dismissed": "Acceso no concedido",
                "ready": "Equipo listo"
            },
            "checking": {
                "title": "Comprobando el micrófono y la cámara…"
            },
            "waiting": {
                "title": "Permita el acceso al micrófono",
                "cameraTitle": "Permita el acceso a la cámara",
                "description": "La solicitud de permiso del navegador ya está abierta. Sin micrófono, la conversación no puede empezar."
            },
            "denied": {
                "title": "El navegador bloquea el micrófono",
                "cameraTitle": "El navegador bloquea la cámara",
                "description": "Su navegador recordó el bloqueo. Permita el acceso al micrófono en la configuración del sitio y vuelva a cargar la página.",
                "cameraDescription": "Su navegador recordó el bloqueo. Permita el acceso a la cámara en la configuración del sitio y vuelva a cargar la página.",
                "showInstructions": "Mostrar cómo",
                "hideInstructions": "Ocultar",
                "chromeEdge": {
                    "browser": "Chrome y Edge",
                    "text": "Haga clic en el icono del candado a la izquierda de la dirección, abra «Configuración del sitio», permita «Micrófono» y vuelva a cargar la página."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Abra el menú de Safari → «Ajustes para este sitio web», permita «Micrófono» y vuelva a cargar la página."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Haga clic en el icono del micrófono en la barra de direcciones, quite el bloqueo para este sitio y vuelva a cargar la página."
                },
                "system": {
                    "title": "Su sistema bloquea el acceso del navegador al micrófono",
                    "cameraTitle": "Su sistema bloquea el acceso del navegador a la cámara",
                    "macos": "macOS: Ajustes del Sistema → Privacidad y seguridad → Micrófono (o Cámara) → active su navegador y reinícielo.",
                    "windows": "Windows: Configuración → Privacidad y seguridad → Micrófono (o Cámara) → permita el acceso a las aplicaciones y a su navegador, y pulse «Reintentar»."
                }
            },
            "busy": {
                "title": "El micrófono está siendo usado por otra aplicación",
                "cameraTitle": "La cámara está siendo usada por otra aplicación",
                "description": "Suele ser una llamada que quedó abierta en segundo plano. Ciérrela y pulse «Reintentar».",
                "retry": "Reintentar"
            },
            "noCamera": {
                "title": "Sin cámara",
                "description": "Se le oirá, pero no se le verá.",
                "requiredByScenario": "Esta conversación requiere una cámara. Conecte una para continuar."
            },
            "missing": {
                "title": "No se encontró ningún micrófono",
                "description": "Conecte un micrófono y pulse «Reintentar». La conversación no puede empezar sin él."
            },
            "dismissed": {
                "title": "No se concedió el acceso al micrófono",
                "cameraTitle": "No se concedió el acceso a la cámara",
                "description": "La ventana del navegador se cerró sin responder. Pulse «Reintentar» y permita el acceso."
            },
            "ready": {
                "title": "Equipo listo"
            },
            "micLabel": "Micrófono",
            "cameraLabel": "Cámara",
            "chooseMic": "Elegir micrófono",
            "chooseCamera": "Elegir cámara",
            "micLevelHint": "Diga algo",
            "speakerValue": "Altavoz: {name}",
            "configure": "Configurar",
            "dialog": {
                "title": "Equipo",
                "lockedDuringConversation": "Los dispositivos no se pueden cambiar durante la conversación.",
                "micSelectLabel": "Micrófono",
                "cameraSelectLabel": "Cámara",
                "speakerSelectLabel": "Altavoz",
                "noCameraOption": "Sin cámara",
                "record": "Grabar 3 segundos",
                "recording": "Grabando…",
                "recordFailed": "No se pudo grabar. Inténtelo de nuevo.",
                "listen": "Reproducir",
                "playing": "Reproduciendo…",
                "done": "Listo",
                "closeAriaLabel": "Cerrar diálogo"
            },
            "unnamed": {
                "microphone": "Micrófono {number}",
                "camera": "Cámara {number}",
                "speaker": "Altavoz {number}"
            },
            "cameraWarmup": {
                "preview": "La cámara se está activando",
                "title": "Micrófono listo",
                "description": "La cámara se activará enseguida: normalmente en uno o dos segundos.",
                "slowHint": "¿La cámara no se activa? Elija otra en «Configurar»."
            }
        },
        "recording": {
            "videoAndAudio": "La conversación y el vídeo se están grabando.",
            "audioOnly": "La conversación se está grabando.",
            "accessSelfAndEvaluators": "La grabación está disponible para usted y para quien evalúe su trabajo.",
            "accessEvaluators": "La grabación está disponible para quien evalúe su trabajo."
        },
        "scenario": {
            "video": "Vídeo del autor del escenario"
        },
        "notes": {
            "title": "Notas de la sesión",
            "placeholder": "Qué quiere practicar, frases que haya preparado",
            "saving": "Guardando…",
            "saved": "Guardado",
            "saveError": "No se pudo guardar",
            "visibility": "Las notas son visibles para usted y para quien evalúe la sesión.",
            "unsupported": "Estas notas contienen elementos que no se pueden editar aquí. Se conservan sin cambios."
        },
        "stage": {
            "agentState": {
                "speaking": "Hablando",
                "listening": "Escuchando",
                "thinking": "Pensando"
            },
            "micOffWarning": "El micrófono está apagado — el interlocutor no le oye",
            "micOnAriaLabel": "Apagar micrófono",
            "micOffAriaLabel": "Encender micrófono",
            "micOff": "Micrófono apagado",
            "micOnAnnouncement": "Micrófono encendido",
            "captionsLabel": "Subtítulos",
            "captionsOnAriaLabel": "Ocultar subtítulos",
            "captionsOffAriaLabel": "Mostrar subtítulos",
            "talkBalance": {
                "title": "Balance de habla",
                "you": "Tú",
                "interlocutor": "Interlocutor"
            },
            "connectionQuality": {
                "excellent": "Conexión excelente",
                "good": "Conexión buena",
                "poor": "Conexión débil",
                "unknown": "Calidad de conexión desconocida"
            },
            "selfCameraLabel": "Tú",
            "timeWarning": {
                "lastMinute": "Queda un minuto — vaya cerrando",
                "finalSeconds": "15 segundos — termine la idea"
            },
            "timeUp": {
                "title": "Se acabó el tiempo",
                "text": "La conversación se cerrará sola; no se puede prolongar.",
                "closing": "Cerrando la conversación…"
            },
            "voiceOnly": "Modo de voz — este escenario no tiene vídeo",
            "interlocutorConnecting": {
                "title": "El interlocutor se está conectando",
                "hint": "Normalmente 2–4 segundos"
            },
            "layout": {
                "label": "Lado a lado",
                "sideTitle": "Colocar lado a lado",
                "focusTitle": "Ampliar al interlocutor"
            }
        },
        "panels": {
            "scenario": "Escenario",
            "transcript": "Transcripción",
            "transcriptEmpty": "Aquí aparecerán las intervenciones terminadas.",
            "notes": "Notas",
            "characterMemoryTab": "Qué recuerda el personaje",
            "openAriaLabel": "Abrir el panel «{panel}»",
            "closeAriaLabel": "Cerrar el panel «{panel}»"
        },
        "sound": {
            "label": "Sonido",
            "volumeLabel": "Volumen",
            "speakerLabel": "Altavoz"
        },
        "end": {
            "button": "Finalizar",
            "confirmTitle": "¿Finalizar la conversación?",
            "elapsed": "Han transcurrido {elapsed} de {total}.",
            "partialEvaluationNotice": "La conversación se evaluará por lo que haya alcanzado a cubrir.",
            "continue": "Continuar",
            "notSent": "La conversación terminará por tiempo: el servidor no respondió a la solicitud de finalización."
        },
        "wait": {
            "title": "Preparando la conversación",
            "hint": "Normalmente tarda 1–3 minutos. No cierre la página — empezaremos automáticamente.",
            "nextTry": "Próximo intento en {time}",
            "trying": "Intentando empezar…",
            "retrying": "Todavía no. Nuevo intento en {time}",
            "cancel": "Cancelar",
            "failed": {
                "title": "No se pudo iniciar la conversación",
                "text": "Ahora mismo no hay plazas libres. Los ajustes del micrófono y la cámara están guardados — inténtelo de nuevo en un par de minutos.",
                "retry": "Intentar de nuevo"
            }
        },
        "connection": {
            "reconnecting": "Conexión perdida, reconectando…",
            "restored": "Conexión restaurada",
            "failed": "No se pudo restablecer la conexión",
            "retry": "Reintentar"
        },
        "hotkeys": {
            "title": "Atajos de teclado",
            "showHintAriaLabel": "Mostrar los atajos de teclado",
            "micToggle": "Alternar micrófono",
            "scenarioPanel": "Escenario: abrir y cerrar el panel",
            "transcriptPanel": "Transcripción",
            "notesPanel": "Notas",
            "captionsToggle": "Alternar subtítulos",
            "closeTopLayer": "Cerrar el panel, popover o diálogo",
            "endConfirm": "Finalizar — abre la confirmación",
            "showHint": "Mostrar esta ayuda"
        },
        "intro": {
            "candidate": {
                "greeting": "¡Hola, {name}!",
                "leadWithVacancy": "{organization} le invita a una entrevista con un interlocutor virtual para la vacante «{vacancy}».",
                "duration": "La entrevista dura aproximadamente {minutes} min.",
                "requirementsTitle": "Qué necesitará",
                "requirementMic": "Micrófono en buen estado; idealmente, auriculares con micrófono",
                "requirementCameraRequired": "Cámara encendida: es obligatoria para esta entrevista",
                "requirementCameraOptional": "La cámara es opcional, pero con ella la conversación resulta más natural",
                "requirementBrowser": "Un equipo con una versión reciente de Chrome, Edge o Safari",
                "requirementNetwork": "Una conexión estable y un lugar tranquilo donde nadie le interrumpa",
                "consentTextLabel": "Texto del consentimiento",
                "consentAccept": "He leído el texto y doy mi consentimiento para el tratamiento de mis datos personales",
                "next": "Siguiente"
            },
            "launch": {
                "title": "Conversación de práctica",
                "lead": "Va a hablar con un interlocutor virtual. La conversación se graba y se evalúa, y el resultado volverá a su sistema de aprendizaje.",
                "requirementsTitle": "Qué necesitará",
                "requirementMic": "Un micrófono en buen estado; idealmente, unos auriculares con micrófono",
                "requirementCamera": "La cámara es opcional, pero con ella la conversación resulta más natural",
                "requirementBrowser": "Un equipo con una versión reciente de Chrome, Edge o Safari",
                "requirementNetwork": "Una conexión estable y un lugar tranquilo donde nadie le interrumpa",
                "start": "Empezar"
            }
        },
        "finished": {
            "candidate": {
                "title": "¡Gracias!",
                "text": "La entrevista ha terminado. El resultado se enviará al reclutador, quien se pondrá en contacto con usted. Ya puede cerrar esta página."
            },
            "launch": {
                "title": "¡Gracias!",
                "text": "La conversación ha terminado. El resultado aparecerá en su sistema de aprendizaje cuando la evaluación esté lista. Puede cerrar esta página."
            }
        },
        "closeDialogAriaLabel": "Cerrar diálogo"
    },
    "loopAvatars": {
        "title": "Avatares en bucle",
        "upload": "Subir avatar",
        "newVersion": "Nueva versión",
        "newVersionHint": "«{name}», versión actual {version}. El nuevo paquete sustituye los vídeos en todos los perfiles con este avatar.",
        "edit": "Editar avatar",
        "delete": "Eliminar avatar",
        "empty": "Aún no hay avatares",
        "headers": {
            "poster": "Póster",
            "name": "Nombre",
            "gender": "Género",
            "emotion": "Emoción",
            "visibility": "Visibilidad",
            "version": "Versión",
            "profiles": "Perfiles"
        },
        "gender": {
            "male": "Masculino",
            "female": "Femenino"
        },
        "emotion": {
            "calm": "Tranquilo",
            "friendly": "Amigable",
            "strict": "Estricto"
        },
        "visibility": {
            "all": "Todas las organizaciones"
        },
        "fields": {
            "package": "Paquete del avatar (.zip)"
        },
        "packageHint": "ZIP de hasta 100 MB con manifest.json, listen.mp4, talk.mp4, transitions.json y poster.jpg",
        "validation": {
            "packageTooLarge": "El paquete no debe superar los 100 MB"
        },
        "errors": {
            "requestFailed": "Error en la solicitud. Inténtalo de nuevo."
        },
        "confirmDetach": "Perfiles que se desvincularán: {count}. Cambiarán a la foto. ¿Guardar?",
        "confirmDelete": "¿Eliminar el avatar «{name}»?",
        "confirmDeleteWithProfiles": "El avatar «{name}» se usa en perfiles: {count}. Cambiarán a la foto. ¿Eliminar?"
    },
    "ttsVoices": {
        "title": "Voces TTS",
        "create": "Añadir voz",
        "edit": "Editar voz",
        "delete": "Eliminar voz",
        "replaceSample": "Sustituir muestra",
        "replaceSampleHint": "«{name}», versión actual de la muestra {version}. La nueva muestra sonará en todos los perfiles con esta voz.",
        "empty": "Aún no hay voces",
        "play": "Escuchar muestra",
        "stop": "Detener",
        "headers": {
            "name": "Nombre",
            "provider": "Proveedor",
            "externalId": "ID de la voz",
            "gender": "Género",
            "languages": "Idiomas",
            "visibility": "Visibilidad",
            "sample": "Muestra",
            "profiles": "Perfiles"
        },
        "gender": {
            "male": "Masculino",
            "female": "Femenino"
        },
        "visibility": {
            "all": "Todas las organizaciones"
        },
        "fields": {
            "sample": "Muestra de voz",
            "speed": "Velocidad del habla"
        },
        "sampleHint": "MP3, MP4 o M4A de hasta 5 MB",
        "sampleOptionalHint": "Opcional: la muestra se generará con la voz a partir de su ID. MP3, MP4 o M4A de hasta 5 MB",
        "synthesizeSample": "Generar de nuevo",
        "speedChangedHint": "Genera de nuevo la muestra de voz para escuchar la nueva velocidad.",
        "speedSamplePromptTitle": "Velocidad modificada",
        "speedSamplePrompt": "La muestra de voz aún suena con la velocidad anterior. ¿Generarla de nuevo? Se reemplazará la muestra actual.",
        "saveAndSynthesize": "Guardar y generar",
        "saveOnly": "Solo guardar",
        "validation": {
            "sampleTooLarge": "La muestra no debe superar los 5 MB"
        },
        "errors": {
            "requestFailed": "Error en la solicitud. Inténtalo de nuevo.",
            "sampleUnavailable": "No se pudo reproducir la muestra"
        },
        "confirmDetach": "Perfiles que se desvincularán: {count}. Cambiarán a la voz del conector. ¿Guardar?",
        "confirmDelete": "¿Eliminar la voz «{name}»?",
        "confirmDeleteWithProfiles": "La voz «{name}» se usa en perfiles: {count}. Cambiarán a la voz del conector. ¿Eliminar?",
        "picker": {
            "none": "Voz predeterminada",
            "empty": "No hay voces de este género en el catálogo",
            "loadError": "No se pudieron cargar las voces",
            "playSample": "Escuchar muestra: {name}",
            "stopSample": "Detener muestra: {name}",
            "sampleUnavailable": "Muestra no disponible"
        }
    },
    "realtimeAvatars": {
        "title": "Avatares Live",
        "create": "Añadir avatar",
        "edit": "Editar avatar",
        "delete": "Eliminar avatar",
        "preview": "Ver vista previa",
        "empty": "Aún no hay avatares",
        "headers": {
            "poster": "Póster",
            "name": "Nombre",
            "provider": "Proveedor",
            "externalId": "ID del avatar",
            "gender": "Género",
            "visibility": "Visibilidad",
            "profiles": "Perfiles",
            "models": "Modelos de Anam"
        },
        "gender": {
            "male": "Masculino",
            "female": "Femenino"
        },
        "visibility": {
            "all": "Todas las organizaciones"
        },
        "nameHint": "Opcional — se usará el nombre de Anam",
        "externalIdHint": "Si cambias el ID, el póster y la vista previa se cargarán de nuevo desde Anam",
        "errors": {
            "requestFailed": "No se pudo completar la solicitud. Inténtalo de nuevo.",
            "previewUnavailable": "No se pudo reproducir la vista previa"
        },
        "confirmDetach": "Perfiles que se desvincularán: {count}. Pasarán a la foto. ¿Guardar?",
        "confirmDelete": "¿Eliminar el avatar «{name}»?",
        "confirmDeleteWithProfiles": "El avatar «{name}» se usa en perfiles: {count}. Pasarán a la foto. ¿Eliminar?",
        "picker": {
            "label": "Avatares Live",
            "empty": "No hay avatares Live disponibles para este perfil",
            "emptyFiltered": "No hay avatares Live de este género",
            "loadError": "No se pudieron cargar los avatares Live"
        }
    },
    "aiProfileAppearance": {
        "label": "Apariencia",
        "photo": "Foto propia",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Mascota",
        "filterGender": "Género",
        "filterEmotion": "Emoción",
        "avatarsLabel": "Avatares",
        "avatarRequired": "Elige un avatar",
        "liveRequired": "Elige un avatar Live",
        "livePlaceholder": "Aquí aparecerá tu avatar Live",
        "empty": "No hay avatares disponibles para este perfil",
        "emptyFiltered": "Ningún avatar coincide con los filtros",
        "loadError": "No se pudieron cargar los avatares",
        "playPreview": "Reproducir vista previa: {name}",
        "pausePreview": "Pausar vista previa: {name}"
    },
  "emailStopList": {
    "title": "Lista de bloqueo de email",
    "description": "Los correos a estas direcciones y dominios no se envían. Una entrada de dominio cubre todas las direcciones de ese dominio, pero no sus subdominios.",
    "searchPlaceholder": "Buscar por dirección o dominio",
    "allReasons": "Todos los motivos",
    "add": "Añadir",
    "addTitle": "Bloquear una dirección o un dominio",
    "empty": "La lista de bloqueo está vacía",
    "editNote": "Editar nota",
    "headers": {
      "type": "Tipo",
      "value": "Dirección o dominio",
      "reason": "Motivo",
      "providerReply": "Respuesta del servicio de correo",
      "note": "Nota",
      "author": "Añadido por",
      "createdAt": "Fecha de adición",
      "blockedCount": "Correos detenidos",
      "lastBlockedAt": "Última detención"
    },
    "type": {
      "address": "Dirección",
      "domain": "Dominio"
    },
    "reason": {
      "manual": "Manualmente",
      "providerRejected": "Rechazado por el servicio de correo"
    },
    "author": {
      "system": "Sistema"
    },
    "fields": {
      "value": "Dirección o dominio",
      "valueHint": "Indique una dirección completa o solo un dominio. Un dominio bloquea todas sus direcciones, pero no los subdominios.",
      "note": "Nota"
    },
    "errors": {
      "requestFailed": "Algo salió mal. Inténtelo de nuevo."
    },
    "unblock": {
      "action": "Desbloquear",
      "confirm": "¿Desbloquear {value}?",
      "resultTitle": "Resultado del desbloqueo",
      "result": {
        "removedEverywhere": "Desbloqueado. El servicio de correo no tiene esta dirección en su lista de bloqueo, así que los correos volverán a enviarse.",
        "removedLocally": "Dominio desbloqueado. Las direcciones de este dominio que tienen su propia entrada siguen bloqueadas.",
        "providerNotConfigured": "Solo se eliminó la entrada de la plataforma: la conexión con el servicio de correo no está configurada, por lo que no se comprobó su lista de bloqueo.",
        "providerUnavailable": "El servicio de correo no está disponible, inténtelo más tarde. La dirección sigue bloqueada.",
        "stillListedAtProvider": "La dirección está en la lista de bloqueo del servicio de correo. Elimínela en el panel del servicio y pulse «Desbloquear de nuevo». Si el panel no muestra la dirección, está en la lista de bloqueo global del servicio y no se puede eliminar desde allí."
      },
      "openPanel": "Abrir el panel del servicio de correo",
      "panelPath": "Dónde eliminarla: panel del servicio de correo → Products → Email Service → su recurso → pestaña Stop Lists.",
      "retry": "Desbloquear de nuevo"
    },
    "suggestions": {
      "text": "El dominio {domain} tiene {count} direcciones bloqueadas. ¿Bloquear todo el dominio?",
      "block": "Bloquear dominio",
      "confirm": "¿Bloquear el dominio {domain}? Los correos a todas sus direcciones dejarán de enviarse. Los subdominios no se ven afectados y las entradas de direcciones individuales se mantienen."
    },
    "check": {
      "title": "Comprobar una dirección",
      "hint": "Muestra si los correos a la dirección están bloqueados por la plataforma o por el servicio de correo",
      "placeholder": "Dirección de email",
      "submit": "Comprobar",
      "resultFor": "Resultado para {email}",
      "platform": "Lista de bloqueo de la plataforma",
      "platformListed": "Sí — entrada «{value}»",
      "provider": "Lista de bloqueo del servicio de correo",
      "listed": "Sí",
      "notListed": "No",
      "providerReasons": "Motivos indicados por el servicio de correo:",
      "providerNotConfigured": "La conexión con el servicio de correo no está configurada",
      "providerUnavailable": "El servicio de correo no está disponible, inténtelo más tarde"
    }
  }
}
